import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import {
  BASE_URL,
  FRONTEND_URL,
  IMAGE_URL,
  TESTING_URL,
} from "../../config/axios";
import {
  AdminOutdutyRequestapproved,
  AdminOutdutyRequestReject,
  AdminRequestReject,
  AdminRequestApprove,
  HRleaveUpdate,
  HROutdutyUpdate,
  ImprestApproveAdmin,
  ImprestRejectAdmin,
  AdminapprovedHR,
  AdminDeleteHR,
  ImprestApprovedAccount,
  CompoffShortLeaveApproved,
  CompoffShortLeaveReject,
} from ".././workforcemanagement/Requestapproved";
import {
  formatDate,
  formatDateTime,
  formattedDate,
  formattedDateLong,
} from "../Date";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import usePermission from "../../config/permissions";
import {
  CustomImageModal,
  customSortByKey,
  DateRangePicker,
  downloadAsExcel,
  formatCurrencyIndian,
  formatRoundoff2D,
  handleAllError,
  handleErrorToast,
} from "../CustomFunctions";
import { AccountBExpenseFinalize } from "../ImprestExpenseManagement/ExpenseSheet/ExpenseSlipComponents";
import {
  Active,
  Calender,
  CircularGrid,
  DeleteDustbin,
  DownloadIcon,
  Employee,
  Eye,
  Filter,
  Office,
  SearchBig,
  Sort,
  AddwithWhiteCircle,
} from "../AllSvg";
import { CSSForFilterDropdown } from "../CustomUtilities";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import AttendanceDataTable from "../UserDetails/userDetails-comp/AttendanceDataTable";
import Loader from "../Loader";
import {
  CustomTooltip,
  ViewDynamicApprovalStatus,
  ViewDynamicApprovalRemarks,
} from "../CustomFunctions";
import {
  DeleteCompoffShortLeaveForm,
  AddCompoffShortLeaveForm,
} from ".././workforcemanagement/RequestManagementComponents";
const today = new Date();
today.setDate(today.getDate() - 60);

const year = today.getFullYear();
const month = today.getMonth() + 1;
const day = today.getDate();

const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
  .toString()
  .padStart(2, "0")}`;

const DeleteLeaveRequest = ({ i, getLeavename }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(
        `${BASE_URL}/wfm/leaveupdatedelete/${i.id}/`,
      );

      if (res.status === 200) {
        await getLeavename();
        handleClose();
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleAllError(err, loadingToastId);
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <button
        title="Delete Leave Request"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h3 className="task-Tab-heading   font-weight500    font-size-heading">
                Confirm Deletion of Leave Request :
              </h3>
              <p style={{ textAlign: "center" }}>
                Employee :{" "}
                <CustomImageModal customStyle>
                  {i.profilepic ? (
                    <img
                      src={`${IMAGE_URL}${i.profilepic}`}
                      alt="profile"
                      className="profile-img"
                    />
                  ) : (
                    <UserDefaultLogo
                      user={{ name: i.name, profilepic: i.profilepic }}
                      customStyleforParent={"reqOutDuty-default-logo-dashboard"}
                      customStyleforChild={"profile-img"}
                    />
                  )}
                </CustomImageModal>
                {i.name}
              </p>
              <p style={{ textAlign: "center" }}>
                Start Date : {formatDate(i.date)}
              </p>
              <p style={{ textAlign: "center" }}>
                End Date : {formatDate(i.end_date)}
              </p>
              <p style={{ textAlign: "center" }} className="text-capitalize">
                Duration : {i.leave_Duration}
              </p>
              <p style={{ textAlign: "center" }} className="text-capitalize">
                Type : {i.leave_type ? i.leave_type : "Previous leaves"}
              </p>
              <p style={{ textAlign: "center" }}>
                Leave Asked : {i.leaveasked}
              </p>
              <p
                style={{ textAlign: "center" }}
                title={`${i.leave_type ? i.leave_type : "previous leaves"}`}
              >
                Leave Balance :{" "}
                {i.leave_type === "sick leave" ? i.sick_leave : ""}
                {i.leave_type === "casual leave" ? i.casual_leave : ""}
                {i.leave_type === "earn leave" ? i.earn_leave : ""}
                {i.leave_type === "previous leave" ? i.leavebalance : ""}
                {i.leave_type === null ? i.leavebalance : ""}
              </p>
              <p style={{ textAlign: "center" }}>
                Reporting Head : {i.rh_assigned}
              </p>
              <p style={{ textAlign: "center" }}>Remark : {i.remarks}</p>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel  font-weight500   "
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteODRequest = ({ i, getoutdutylist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(
        `${BASE_URL}/wfm/outdutyupdatedelete/${i.id}/`,
      );

      if (res.status === 200) {
        await getoutdutylist();
        handleClose();
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleAllError(err, loadingToastId);
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <button
        title="Delete OD Request"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h3 className="task-Tab-heading   font-weight500    font-size-heading">
                Confirm Deletion of OutDuty Request :
              </h3>
              <p style={{ textAlign: "center" }}>
                Employee :{" "}
                <CustomImageModal customStyle>
                  {i.profilepic ? (
                    <img
                      src={`${IMAGE_URL}${i.profilepic}`}
                      alt="profile"
                      className="profile-img"
                    />
                  ) : (
                    <UserDefaultLogo
                      user={{ name: i.name, profilepic: i.profilepic }}
                      customStyleforParent={"reqOutDuty-default-logo-dashboard"}
                      customStyleforChild={"profile-img"}
                    />
                  )}
                </CustomImageModal>
                {i.name}
              </p>
              <p style={{ textAlign: "center" }}>
                Start Date : {formatDate(i.date)}
              </p>
              <p style={{ textAlign: "center" }}>
                End Date : {formatDate(i.end_date)}
              </p>
              <p style={{ textAlign: "center" }} className="text-capitalize">
                Duration : {i.outduty_Duration}
              </p>
              <p style={{ textAlign: "center" }}>
                Reporting Head : {i.rh_assigned}
              </p>
              <p style={{ textAlign: "center" }}>Remark : {i.remarks}</p>
              <div className="button-models">
                <button
                  className="model-button  model-button-cancel font-weight500   "
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const Requestoutdutytable = () => {
  const { PERMISSION_AUTHORITY, PORTAL_SETTINGS, SUPER_ADMIN } =
    usePermission();
  const [checkedItems, setCheckedItems] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [outdutyList, setOutdutyList] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [selectedRhStatus, setSelectedRHStatus] = useState("approved");

  const [employeeGet, setEmployeeGet] = useState("null");
  const [startdate, setStartDate] = useState("null");
  const [enddate, setEndDate] = useState("null");
  const [rhname, setRhname] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [outDutyDateEmpFilter, setOutDutyDateEmpFilter] = useState("null");

  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  const [active, setActive] = useState("active");

  const [SubCompany, setSubCompany] = useState([]);

  const nullOption = { value: "null", label: "Select Employee Code" };
  const employeeOptions = allemployee
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleEmployeeChange = (selectedOption) => {
    setEmployeeGet(selectedOption ? selectedOption.value : "null");
    setCheckedItems([]);
  };

  const getSubCompany = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      //toast Logic
      handleAllError(err);
    } finally {
      setBuffering1(false); // End Buffering
    }
  };

  const getEmpcode = async () => {
    setBuffering2(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllemployee(sortedList);
    } catch (err) {
      //toast Logic
      handleAllError(err);
    } finally {
      setBuffering2(false); // End Buffering
    }
  };

  const latestRequestRef = useRef(0);

  const getoutdutylist = async () => {
    const requestId = ++latestRequestRef.current; // 👈 mark this request

    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/outdutyadminget/${selectedRhStatus}/${startdate}/${enddate}/${selectedStatus}/${employeeGet}/${selectedDivision}/${active}/`,
      );

      if (requestId !== latestRequestRef.current) return;

      let filteredData = res.data;

      switch (outDutyDateEmpFilter) {
        case "asc_empcode":
          filteredData = filteredData.sort((a, b) =>
            a.empcode.localeCompare(b.empcode),
          );
          break;
        case "desc_empcode":
          filteredData = filteredData.sort((a, b) =>
            b.empcode.localeCompare(a.empcode),
          );
          break;
        case "asc_name":
          filteredData = filteredData.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          break;
        case "desc_name":
          filteredData = filteredData.sort((a, b) =>
            b.name.localeCompare(a.name),
          );
          break;
        case "asc_date":
          filteredData = filteredData.sort(
            (a, b) => new Date(a.date) - new Date(b.date),
          );
          break;
        case "desc_date":
          filteredData = filteredData.sort(
            (a, b) => new Date(b.date) - new Date(a.date),
          );
          break;
        default:
          break;
      }

      setOutdutyList(res.data);
      setFiltered(filteredData);
    } catch (err) {
      //toast Logic
      handleAllError(err);
    } finally {
      // ✅ Only latest request can stop loader
      if (requestId === latestRequestRef.current) {
        setBuffering(false); //buffering logic // End Buffering
      }
    }
  };

  useEffect(() => {
    getoutdutylist();
    getSubCompany();
    getEmpcode();
  }, [
    selectedRhStatus,
    outDutyDateEmpFilter,
    startdate,
    enddate,
    selectedStatus,
    employeeGet,
    active,
    selectedDivision,
  ]);

  // *********** Employee Details Api End ***********

  const handleSearch = () => {
    let filteredData = outdutyList;
    if (rhname) {
      const lowercaseSelectedName = rhname.toLowerCase();
      filteredData = filteredData.filter((i) => {
        const matchedName = i.rh_name
          .toLowerCase()
          .includes(lowercaseSelectedName);

        const matchedCode = i.rh_assigned
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return matchedName || matchedCode;
      });
    }

    if (startdate !== "" && enddate !== "") {
      filteredData = filteredData.filter(
        (ot) =>
          (ot.date >= startdate && ot.date <= enddate) ||
          (ot.end_date >= startdate && ot.end_date <= enddate),
      );
    }

    setFiltered(filteredData);
  };

  useEffect(() => {
    handleSearch();
  }, [rhname, startdate, enddate]);

  const handleCheckboxChange = (id) => {
    const currentIndex = checkedItems.indexOf(id);
    const newCheckedItems = [...checkedItems];

    if (currentIndex === -1) {
      newCheckedItems.push(id);
    } else {
      newCheckedItems.splice(currentIndex, 1);
    }
    setCheckedItems(newCheckedItems);
  };

  const bulkUpdateData = checkedItems.map((reqid) => {
    return {
      id: reqid,
      // rh_leave_status: "approved",
      admin_leave_status: "approved",
      hr_update_datetime: new Date().toISOString(),
    };
  });

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmitApprovePut = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(
        `${BASE_URL}/wfm/bulk-outduty-updateorrectify-byportalsettings/rectify/`,
        bulkUpdateData,
      );

      if (res.status === 200) {
        setCheckedItems([]);
        await getoutdutylist();
      } else {
        toast.warning(res);
      }
    } catch (err) {
      handleAllError(err, loadingToastId);
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };
  const handleOutDutyDateEmpChange = (e) =>
    setOutDutyDateEmpFilter(e.target.value);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              {PERMISSION_AUTHORITY ? (
                <div className="field-cont-div">
                  {buffer1 ? (
                    <div className="spinner-vsmall"></div>
                  ) : (
                    <Office />
                  )}
                  <select
                    className="attendance-input-field width-10vw   date-field"
                    type="text"
                    value={selectedDivision}
                    onChange={(e) => {
                      setDivision(e.target.value);
                      setCheckedItems([]);
                    }}
                  >
                    <option value=""> All Sub Companies</option>
                    {SubCompany.sort((a, b) => a.title - b.title).map(
                      (i, index) => (
                        <option value={i.id}>{i.title}</option>
                      ),
                    )}
                    ;
                  </select>
                  <hr className="field-cont-hr" />
                </div>
              ) : null}
            </div>

            <div title=" Date Range" className="field-cont-div ">
              <DateRangePicker
                startDate={startdate}
                endDate={enddate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || "null");
                  setEndDate(end || "null");
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                title="Reporting Head Action Status"
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedRhStatus}
                onChange={(e) => {
                  setSelectedRHStatus(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                title="Admin Action Status"
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            {/* <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => {
                  setEmployeeGet(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">Select Employee Code</option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
              </select>
              <hr className="field-cont-hr" />
            </div> */}

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}

              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === employeeGet,
                  ) || nullOption
                }
                placeholder="Select Employee Code"
                onChange={handleEmployeeChange}
                isClearable
                styles={CSSForFilterDropdown}
              />

              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div-svg">
              <SearchBig />
              <input
                className="attendance-input-field width-16vw  "
                placeholder="Select Reporting head"
                type="text"
                value={rhname}
                onChange={(e) => setRhname(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => {
                  setActive(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw date-field"
                value={outDutyDateEmpFilter}
                onChange={handleOutDutyDateEmpChange}
              >
                <option value="null">No Sorting</option>
                <option value="asc_empcode">Asc.Emp Code </option>
                <option value="desc_empcode">Desc.Emp Code </option>
                <option value="asc_name">Asc.Name </option>
                <option value="desc_name">Desc.Name </option>
                <option value="asc_date">Asc.Date </option>
                <option value="desc_date">Desc.Date </option>
              </select>

              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont">
            <HROutdutyUpdate getoutdutylist={getoutdutylist} />
          </div>
        </div>
      </div>

      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500 font-size-heading">
            Outduty
          </div>
          {/* Easter Egg! */}
          {/* {outdutyList.length === 0 ? "Cant Find Something? Try Changing Filter! :)" : ""} */}

          <div className="flex-row">
            {checkedItems.length > 0 ? (
              <>
                <div className="align-center">
                  <div className=" font-size-heading">
                    {`Selected : ${checkedItems.length}`}{" "}
                  </div>
                </div>
                <hr className="field-cont-hr" />
                {selectedRhStatus === "approved" &&
                  selectedStatus === "pending" ? (
                  <>
                    <button
                      className="model-button s-submit-btn font-weight500 fs-17"
                      onClick={handleFormSubmitApprovePut}
                      disabled={loading}
                    >
                      Accept
                    </button>
                    {/* <hr className="field-cont-hr" />
                    <button className="model-button model-button-delete   font-weight500"
                      onClick={handleFormSubmitRejectedPut}
                    >
                      Rejected
                    </button> */}
                  </>
                ) : null}
              </>
            ) : null}
          </div>
        </div>

        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr.no</th>
              {selectedRhStatus === "approved" &&
                selectedStatus === "pending" ? (
                <th className="align-left">
                  <label className="checkbox-click">
                    <input
                      type="checkbox"
                      checked={checkedItems.length > 0 ? true : false}
                      onChange={(e) => {
                        if (e.target.checked) {
                          const ids = outdutyList.map((data) => data.id);
                          setCheckedItems(ids);
                        } else {
                          setCheckedItems([]);
                        }
                      }}
                    />
                    <div className="checkmark-small "></div>
                  </label>
                </th>
              ) : null}
              <th className="align-center">Profile </th>
              <th className="align-center">OD start</th>
              <th className="align-center">OD end</th>
              <th className="align-center">OD Duration</th>
              {/* <th className="align-center">Leave Asked</th>
              <th className="align-center">Leave Balance</th> */}
              <th className="align-center">Reporting Head</th>
              <th className="align-center">Remarks</th>
              <th className="align-center">Attendance Data</th>
              <th className="align-center">Status</th>
              <th className="align-right">Action</th>
            </tr>
          </thead>
          {buffer ? (
            <div className="spinner"></div> //buffering logic
          ) : (
            <tbody>
              {filtered.map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    {/* <div className="width-5vw"> */}
                    <td className="align-left">{index + 1}</td>

                    {selectedRhStatus === "approved" &&
                      selectedStatus === "pending" ? (
                      <td className="align-left ">
                        <label className="checkbox-click">
                          <input
                            type="checkbox"
                            checked={checkedItems.indexOf(i.id) !== -1}
                            onChange={() => handleCheckboxChange(i.id)}
                          />
                          <div className="checkmark-small"></div>
                        </label>
                      </td>
                    ) : null}

                    {/* </div> */}

                    <td className="align-center">
                      <CustomImageModal customStyle>
                        {i.profilepic ? (
                          <img
                            src={`${IMAGE_URL}${i.profilepic}`}
                            className="profile-img"
                            alt={i?.name}
                          />
                        ) : (
                          <UserDefaultLogo
                            user={{ name: i.name, profilepic: i.profilepic }}
                            customStyleforParent={"reqOutDuty-default-logo"}
                            customStyleforChild={"small-profile"}
                          />
                        )}
                      </CustomImageModal>
                      <p>
                        {i.empcode}-{i.name}
                      </p>
                    </td>

                    {/* <td className="align-center">{i.name}</td> */}
                    <td className="align-center">{formatDate(i.date)}</td>
                    <td className="align-center">{formatDate(i.end_date)}</td>
                    <td className="align-center text-capitalize">
                      {i.outduty_Duration}
                    </td>
                    {/* <td className="align-center">{i.leaveasked}</td>
                  <td className="align-center">{i.leavebalance}</td> */}
                    {/* <td className="align-center">{i.negativeattendance}</td> */}
                    {/* <td className="align-center">{i.rh_assigned}</td> */}
                    <td className="align-center">
                      <CustomImageModal customStyle>
                        {i.rh_profilepic ? (
                          <img
                            src={`${IMAGE_URL}${i.rh_profilepic}`}
                            className="profile-img"
                            alt={i?.rh_name}
                          />
                        ) : (
                          <UserDefaultLogo
                            user={{
                              name: i.rh_name,
                              profilepic: i.rh_profilepic,
                            }}
                            customStyleforParent={"reqOutDuty-default-logo"}
                            customStyleforChild={"small-profile"}
                          />
                        )}
                      </CustomImageModal>
                      <p>
                        {i.rh_assigned}-{i.rh_name}
                      </p>
                    </td>
                    <td className="align-center">{i.remarks}</td>
                    <td className="align-center">
                      {i.attendance_details &&
                        i.attendance_details.length > 0 ? (
                        <AttendanceDataTable
                          attendanceData={i?.attendance_details}
                          duration={i?.outduty_Duration}
                        />
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className="align-center">
                      <span
                        request-status={i.rh_leave_status}
                        className="request-status align-center"
                      >
                        {i.rh_leave_status === "pending"
                          ? "Pending For Rh Approval ⌛"
                          : i.rh_leave_status === "rejected"
                            ? "Rh Rejected ✖, "
                            : "Rh Approved ✔, "}
                      </span>
                      <br />
                      <span
                        request-status={i.admin_leave_status}
                        className="request-status align-center"
                      >
                        {i.rh_leave_status === "rejected" &&
                          i.admin_leave_status === "rejected"
                          ? "Admin Rejected ✖, "
                          : i.rh_leave_status === "approved" &&
                            i.admin_leave_status === "pending"
                            ? "Pending For Admin Approval ⌛,"
                            : i.rh_leave_status === "approved" &&
                              i.admin_leave_status === "rejected"
                              ? "Admin Rejected ✖, "
                              : i.rh_leave_status === "approved" &&
                                i.admin_leave_status === "approved"
                                ? "Admin Approved ✔, "
                                : ""}
                      </span>
                    </td>
                    <td className="align-right">
                      {i.rh_leave_status === "rejected" ? (
                        PERMISSION_AUTHORITY ? (
                          <DeleteODRequest
                            i={i}
                            getoutdutylist={getoutdutylist}
                          />
                        ) : null
                      ) : i.admin_leave_status === "pending" ? (
                        <div className="flex-row">
                          {i.rh_leave_status === "pending" &&
                            PORTAL_SETTINGS.od_final_bypass
                            ? (() => {
                              const approvalLimit =
                                PORTAL_SETTINGS?.od_approval_limit;
                              const applyDate = new Date(i.apply_datetime);
                              const now = new Date();

                              if (
                                approvalLimit !== null &&
                                approvalLimit !== "" &&
                                approvalLimit > 0
                              ) {
                                const deadline = new Date(applyDate);
                                deadline.setDate(
                                  deadline.getDate() + Number(approvalLimit),
                                );
                                if (now > deadline) {
                                  return (
                                    <AdminOutdutyRequestapproved
                                      i={i}
                                      getoutdutylist={getoutdutylist}
                                      bypass={PORTAL_SETTINGS.od_final_bypass}
                                    />
                                  );
                                } else {
                                  return (
                                    <span className="required">
                                      Approval period of {approvalLimit} days
                                      not expired
                                    </span>
                                  );
                                }
                              }
                            })()
                            : ""}
                          {i.rh_leave_status === "approved" && (
                            <>
                              <AdminOutdutyRequestapproved
                                i={i}
                                getoutdutylist={getoutdutylist}
                              />
                              <AdminOutdutyRequestReject
                                i={i}
                                getoutdutylist={getoutdutylist}
                              />
                            </>
                          )}
                        </div>
                      ) : (
                        <span
                          className="request-status align-center text-capitalize"
                          request-status={i.admin_leave_status}
                        >
                          Admin : {i.admin_leave_status}
                        </span>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </>
  );
};

const RequestLeavetable = () => {
  const { PERMISSION_AUTHORITY, PORTAL_SETTINGS } = usePermission();
  const [checkedItems, setCheckedItems] = useState([]);
  // console.log(checkedItems);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [leaveRequests, setLeaveRequests] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [selectedRhStatus, setSelectedRHStatus] = useState("approved");

  const [employeeGet, setEmployeeGet] = useState("null");
  const [startdate, setStartDate] = useState(`${formattedDatee}`);
  const [enddate, setEndDate] = useState(`${formattedDate}`);
  const [rhname, setRhname] = useState("");
  const [leaveDateEmpFilter, setLeaveDateEmpFilter] = useState("null");
  const [filtered, setFiltered] = useState([]);

  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  const [active, setActive] = useState("active");

  const [SubCompany, setSubCompany] = useState([]);

  const nullOption = { value: "null", label: "Select Employee Code" };
  const employeeOptions = allemployee
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleEmployeeChange = (selectedOption) => {
    setEmployeeGet(selectedOption ? selectedOption.value : "null");
    setCheckedItems([]);
  };

  const getSubCompany = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  const getEmpcode = async () => {
    setBuffering2(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllemployee(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering2(false); //buffering logic // End Buffering
    }
  };

  const getLeavesList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/leaveadminget/${selectedRhStatus}/${startdate}/${enddate}/${selectedStatus}/${employeeGet}/${selectedDivision}/${active}/`,
      );

      let filteredData = res.data;

      switch (leaveDateEmpFilter) {
        case "asc_empcode":
          filteredData = filteredData.sort((a, b) =>
            a.empcode.localeCompare(b.empcode),
          );
          break;
        case "desc_empcode":
          filteredData = filteredData.sort((a, b) =>
            b.empcode.localeCompare(a.empcode),
          );
          break;
        case "asc_name":
          filteredData = filteredData.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          break;
        case "desc_name":
          filteredData = filteredData.sort((a, b) =>
            b.name.localeCompare(a.name),
          );
          break;
        case "asc_date":
          filteredData = filteredData.sort(
            (a, b) => new Date(a.date) - new Date(b.date),
          );
          break;
        case "desc_date":
          filteredData = filteredData.sort(
            (a, b) => new Date(b.date) - new Date(a.date),
          );
          break;
        default:
          break;
      }

      setLeaveRequests(res.data);
      setFiltered(filteredData);
      // console.log(res.data)
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getLeavesList();
    getEmpcode();
    getSubCompany();
  }, [
    selectedRhStatus,
    leaveDateEmpFilter,
    startdate,
    enddate,
    selectedStatus,
    employeeGet,
    active,
    selectedDivision,
  ]);

  // *********** Employee Details Api End ***********
  const handleSearch = () => {
    let filteredData = leaveRequests;
    if (rhname) {
      const lowercaseSelectedName = rhname.toLowerCase();
      filteredData = filteredData.filter((i) => {
        const matchedName = i.rh_name
          .toLowerCase()
          .includes(lowercaseSelectedName);

        const matchedCode = i.rh_assigned
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return matchedName || matchedCode;
      });
    }
    if (startdate !== "" && enddate !== "") {
      filteredData = filteredData.filter(
        (employee) =>
          (employee.date >= startdate && employee.date <= enddate) ||
          (employee.end_date >= startdate && employee.end_date <= enddate),
      );
    }
    setFiltered(filteredData);
  };

  useEffect(() => {
    handleSearch();
  }, [rhname, startdate, enddate]);

  const handleCheckboxChange = (id) => {
    const currentIndex = checkedItems.indexOf(id);
    const newCheckedItems = [...checkedItems];

    if (currentIndex === -1) {
      newCheckedItems.push(id);
    } else {
      newCheckedItems.splice(currentIndex, 1);
    }

    setCheckedItems(newCheckedItems);
  };

  const bulkUpdateData = checkedItems.map((reqid) => {
    return {
      id: reqid,
      // rh_leave_status: "approved",
      admin_leave_status: "approved",
      hr_update_datetime: new Date().toISOString(),
    };
  });

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmitApprovePut = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(
        `${BASE_URL}/wfm/bulk-leave-updateorrectify-byportalsettings/rectify/`,
        bulkUpdateData,
      );
      // BulkLeaveRectify
      if (res.status === 200) {
        setCheckedItems([]);
        await getLeavesList();
      } else {
        toast.warning(res);
      }
    } catch (err) {
      handleAllError(err);
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  const handleLeaveDateEmpChange = (e) => setLeaveDateEmpFilter(e.target.value);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {PERMISSION_AUTHORITY ? (
              <div className="field-cont-div">
                {buffer1 ? <div className="spinner-vsmall"></div> : <Office />}
                <select
                  className="attendance-input-field width-10vw   date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => {
                    setDivision(e.target.value);
                    setCheckedItems([]);
                  }}
                >
                  <option value=""> All Sub Companies</option>
                  {SubCompany.sort((a, b) => a.title - b.title).map(
                    (i, index) => (
                      <option value={i.id}>{i.title}</option>
                    ),
                  )}
                  ;
                </select>
                <hr className="field-cont-hr" />
              </div>
            ) : null}

            <div title=" Date Range" className="field-cont-div ">
              <DateRangePicker
                startDate={startdate}
                endDate={enddate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || formattedDatee);
                  setEndDate(end || formattedDate);
                }}
              />
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />
              <select
                title="Reporting Head Action Status"
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedRhStatus}
                onChange={(e) => {
                  setSelectedRHStatus(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                title="Admin Action Status"
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            {/* <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}
              <select
                className="attendance-input-field width-15vw date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => {
                  setEmployeeGet(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">Select Employee Code</option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div> */}
            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}

              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === employeeGet,
                  ) || nullOption
                }
                placeholder="Select Employee Code"
                onChange={handleEmployeeChange}
                isClearable
                styles={CSSForFilterDropdown}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div-svg">
              <SearchBig />
              <input
                className="attendance-input-field width-16vw  "
                placeholder="Select Reporting head"
                type="text"
                value={rhname}
                onChange={(e) => setRhname(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => {
                  setActive(e.target.value);
                  setCheckedItems([]);
                }}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw date-field"
                value={leaveDateEmpFilter}
                onChange={handleLeaveDateEmpChange}
              >
                <option value="null">No Filter</option>
                <option value="asc_empcode">Asc.Emp Code </option>
                <option value="desc_empcode">Desc.Emp Code </option>
                <option value="asc_name">Asc.Name </option>
                <option value="desc_name">Desc.Name </option>
                <option value="asc_date">Asc.Date </option>
                <option value="desc_date">Desc.Date </option>
              </select>

              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont">
            <HRleaveUpdate getleavelist={getLeavesList} PORTAL_SETTINGS={PORTAL_SETTINGS} />
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Leave{" "}
            </div>
            {/* Easter Egg! */}
            {/* {leaveRequests.length === 0 ? "Cant Find Something? Try Changing Filter! :)" : ""} */}

            <div className="flex-row">
              {checkedItems.length > 0 ? (
                <>
                  <div className="align-center">
                    <div className=" font-size-heading">
                      {`Selected : ${checkedItems.length}`}{" "}
                    </div>
                  </div>
                  <hr className="field-cont-hr" />
                  {selectedRhStatus === "approved" &&
                    selectedStatus === "pending" ? (
                    <>
                      <button
                        className="model-button s-submit-btn font-weight500 fs-17"
                        onClick={handleFormSubmitApprovePut}
                        disabled={loading}
                      >
                        Accept
                      </button>
                      {/* <hr className="field-cont-hr" />
                      <button className="model-button model-button-delete   font-weight500"
                        onClick={handleFormSubmitRejectedPut}
                      >
                        Rejected
                      </button> */}
                    </>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-leftt">Sr.no</th>
                {selectedRhStatus === "approved" &&
                  selectedStatus === "pending" ? (
                  <th className="align-leftt">
                    <label className="checkbox-click">
                      <input
                        type="checkbox"
                        checked={checkedItems.length > 0 ? true : false}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const ids = leaveRequests.map((data) => data.id);
                            setCheckedItems(ids);
                          } else {
                            setCheckedItems([]);
                          }
                        }}
                      />
                      <div className="checkmark-small "></div>
                    </label>
                  </th>
                ) : null}

                {/* <th className="align-center">Date</th> */}
                <th className="align-center">Profile </th>
                {/* <th className="align-center">Empolyee Name</th> */}
                {/* <th className="align-center">OD applied</th> */}
                <th className="align-center">Leave Start</th>
                <th className="align-center">Leave end</th>
                <th className="align-center">Leave Duration</th>
                <th className="align-center">Leave Type</th>
                <th className="align-center">Leave Asked</th>
                <th className="align-center">Leave Balance</th>
                {/* <th className="align-center">Negative Attendance</th> */}
                <th className="align-center">Reporting Head</th>
                <th className="align-center">Attendance Data</th>
                {/* <th className="align-center">RH Leave Status</th> */}
                {/* <th className="align-center">Admin Leave Status</th> */}
                {/* <th className="align-center">Attendance Certified</th> */}
                <th className="align-center">Remarks</th>
                <th className="align-center">Status</th>
                <th className="align-right">Action</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {filtered.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      {/* <div className="width-5vw"> */}
                      <td className="align-leftt">{index + 1}</td>
                      {selectedRhStatus === "approved" &&
                        selectedStatus === "pending" ? (
                        <td className="align-leftt ">
                          <label className="checkbox-click">
                            <input
                              type="checkbox"
                              checked={checkedItems.indexOf(i.id) !== -1}
                              onChange={() => handleCheckboxChange(i.id)}
                            />
                            <div className="checkmark-small "></div>
                          </label>
                        </td>
                      ) : null}

                      {/* </div> */}

                      {/* <td className="align-center">{i.date}</td> */}
                      <td className="align-center">
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.name, profilepic: i.profilepic }}
                              customStyleforParent={"reqOutDuty-default-logo"}
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode}-{i.name}
                        </p>
                      </td>

                      {/* <img src={i.profilepic != "" ? `${IMAGE_URL}${i.profilepic}` : 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'} alt="image" className="employee-card-imageee" /> */}
                      {/* <td className="align-center">{i.profilepic}</td> */}

                      {/* <td className="align-center">{i.name}</td> */}
                      <td className="align-center">{formatDate(i.date)}</td>
                      <td className="align-center">{formatDate(i.end_date)}</td>
                      <td className="align-center text-capitalize">
                        {i.leave_Duration}
                      </td>
                      <td className="align-center text-capitalize">
                        {i.leave_type ? i.leave_type : "Previous leaves"}
                      </td>
                      <td className="align-center">{i.leaveasked}</td>
                      {/* <td className="align-center">{i.leavebalance}</td> */}
                      <td className="align-center">
                        <CustomTooltip
                          position="top"
                          tooltipContent={
                            <div>
                              <div>
                                Previous Leave:{" "}
                                <strong>{i?.leavebalance}</strong>
                              </div>
                              <div>
                                Casual Leave: <strong>{i?.casual_leave}</strong>
                              </div>
                              <div>
                                Sick Leave: <strong>{i?.sick_leave}</strong>
                              </div>
                              <div>
                                Earn Leave: <strong>{i?.earn_leave}</strong>
                              </div>
                              <div>
                                Short Leave: <strong>{i?.short_leave}</strong>
                              </div>
                            </div>
                          }
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                              color: "#2576bc",
                            }}
                            title={`${i.leave_type ? i.leave_type : "previous leaves"}`}
                          >
                            {/* {i?.leavebalance} */}
                            {i.leave_type === "previous leave"
                              ? i.leavebalance
                              : ""}
                            {i.leave_type === "casual leave"
                              ? i.casual_leave
                              : ""}
                            {i.leave_type === "sick leave" ? i.sick_leave : ""}
                            {i.leave_type === "earn leave" ? i.earn_leave : ""}
                            {i.leave_type === "short leave"
                              ? i.short_leave
                              : ""}
                            {i.leave_type === "" || i.leave_type === null
                              ? i.leavebalance
                              : ""}
                          </span>
                        </CustomTooltip>
                      </td>

                      {/* <td className="align-center">{i.negativeattendance}</td> */}
                      <td className="align-center">
                        <CustomImageModal customStyle>
                          {i.rh_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.rh_profilepic}`}
                              className="profile-img"
                              alt={i?.rh_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{
                                name: i.rh_name,
                                profilepic: i.rh_profilepic,
                              }}
                              customStyleforParent={"reqOutDuty-default-logo"}
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.rh_assigned}-{i.rh_name}
                        </p>
                      </td>
                      <td className="align-center">
                        {i.attendance_details &&
                          i.attendance_details.length > 0 ? (
                          <AttendanceDataTable
                            attendanceData={i?.attendance_details}
                            duration={i?.leave_Duration}
                          />
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="align-center">{i.remarks}</td>
                      <td className="align-center">
                        <span
                          request-status={i.rh_leave_status}
                          className="request-status align-center"
                        >
                          {i.rh_leave_status === "pending"
                            ? "Rh ⌛"
                            : i.rh_leave_status === "rejected"
                              ? "Rh ✖, "
                              : "Rh ✔, "}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_leave_status}
                          className="request-status align-center"
                        >
                          {i.rh_leave_status === "rejected" &&
                            i.admin_leave_status === "rejected"
                            ? "Admin ✖, "
                            : i.rh_leave_status === "approved" &&
                              i.admin_leave_status === "pending"
                              ? "Admin ⌛,"
                              : i.rh_leave_status === "approved" &&
                                i.admin_leave_status === "rejected"
                                ? "Admin ✖, "
                                : i.rh_leave_status === "approved" &&
                                  i.admin_leave_status === "approved"
                                  ? "Admin ✔, "
                                  : ""}
                        </span>
                      </td>
                      <td className="align-right flex-row">
                        {/* <AdminRequestApprove i={i} getLeavesList={getLeavesList} />
                      <AdminRequestReject i={i} getLeavesList={getLeavesList} /> */}

                        {i.rh_leave_status === "rejected" ||
                          i.admin_leave_status === "rejected" ? (
                          PERMISSION_AUTHORITY ? (
                            <DeleteLeaveRequest
                              i={i}
                              getLeavename={getLeavesList}
                            />
                          ) : null
                        ) : i.admin_leave_status === "pending" ? (
                          <div className="flex-row">
                            {i.rh_leave_status === "pending" &&
                              PORTAL_SETTINGS.leave_final_bypass
                              ? (() => {
                                const approvalLimit =
                                  PORTAL_SETTINGS?.leave_approval_limit;
                                const applyDate = new Date(i.apply_datetime);
                                const now = new Date();
                                if (
                                  approvalLimit !== null &&
                                  approvalLimit !== "" &&
                                  approvalLimit > 0
                                ) {
                                  const deadline = new Date(applyDate);
                                  deadline.setDate(
                                    deadline.getDate() +
                                    Number(approvalLimit),
                                  );
                                  if (now > deadline) {
                                    return (
                                      <AdminRequestApprove
                                        i={i}
                                        getLeavesList={getLeavesList}
                                        bypass={
                                          PORTAL_SETTINGS.leave_final_bypass
                                        }
                                      />
                                    );
                                  } else {
                                    return (
                                      <span className="required">
                                        Approval period of {approvalLimit}{" "}
                                        days not expired
                                      </span>
                                    );
                                  }
                                }
                              })()
                              : ""}
                            {i.rh_leave_status === "approved" && (
                              <>
                                <AdminRequestApprove
                                  i={i}
                                  getLeavesList={getLeavesList}
                                />
                                <AdminRequestReject
                                  i={i}
                                  getLeavesList={getLeavesList}
                                />
                              </>
                            )}
                          </div>
                        ) : (
                          <span
                            className="request-status align-center text-capitalize"
                            request-status={i.admin_leave_status}
                          >
                            Admin : {i.admin_leave_status}
                          </span>
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const LogCompensatorytable = () => {
  const {
    PERMISSION_AUTHORITY,
    PORTAL_SETTINGS,
    SUPER_ADMIN,
    SUB_COMPANIES,
    PERMISSION_HR_ADMIN,
  } = usePermission();
  // const [checkedItems, setCheckedItems] = useState([]);
  // const [date, setDate] = useState();
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [employeeList, setEmployeeList] = useState([]);
  // const [date, setDate] = useState(`${formattedDate}`);
  const [startdate, setStartDate] = useState(`${formattedDatee}`);
  const [enddate, setEndDate] = useState(`${formattedDate}`);
  const [selectedStatus, setSelectedStatus] = useState("null");
  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [rhname, setRhname] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  const [logDateEmpFilter, setLogDateEmpFilter] = useState("null");

  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };

  // *********** Employee Details Api Start ***********
  const [compensatoryList, setCompensatoryList] = useState([]);

  const getEmpList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
    }
  };

  const getCompensatoryList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/shortandcompoff/${startdate}/${enddate}/null/${selectedStatus}/${employeeGet}/${selectedDivision}/${active}/`,
      );

      let filteredData = res.data;

      switch (logDateEmpFilter) {
        case "asc_empcode":
          filteredData = filteredData.sort((a, b) =>
            a.empcode.localeCompare(b.empcode),
          );
          break;
        case "desc_empcode":
          filteredData = filteredData.sort((a, b) =>
            b.empcode.localeCompare(a.empcode),
          );
          break;
        case "asc_name":
          filteredData = filteredData.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          break;
        case "desc_name":
          filteredData = filteredData.sort((a, b) =>
            b.name.localeCompare(a.name),
          );
          break;
        case "asc_date":
          filteredData = filteredData.sort(
            (a, b) => new Date(a.date) - new Date(b.date),
          );
          break;
        case "desc_date":
          filteredData = filteredData.sort(
            (a, b) => new Date(b.date) - new Date(a.date),
          );
          break;
        default:
          break;
      }
      setCompensatoryList(res.data);
      setFiltered(filteredData);
      // setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getCompensatoryList();
    getEmpList();
    getSubCompany();
  }, [
    employeeGet,
    logDateEmpFilter,
    startdate,
    enddate,
    selectedStatus,
    active,
    selectedDivision,
  ]);

  useEffect(() => { }, []);

  // useEffect(() => {
  //   getEmpList();
  // }, [active, selectedDivision]);

  const handleSearch = () => {
    let filteredData = compensatoryList;
    if (rhname) {
      const lowercaseSelectedName = rhname.toLowerCase();
      filteredData = filteredData.filter((i) => {
        const matchedName = i.rh_name
          .toLowerCase()
          .includes(lowercaseSelectedName);

        const matchedCode = i.rh_assigned
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return matchedName || matchedCode;
      });
    }

    if (startdate) {
      filteredData = filteredData.filter((i) => i.date >= startdate);
    }
    if (enddate) {
      filteredData = filteredData.filter((i) => i.date <= enddate);
    }

    setFiltered(filteredData);
  };

  useEffect(() => {
    handleSearch();
  }, [rhname, startdate, enddate]);

  const handleLogDateEmpChange = (e) => setLogDateEmpFilter(e.target.value);

  const tableRef = useRef(null);
  const handleDownloadExcel = () => {
    downloadAsExcel(
      tableRef,
      "compensatory",
      employeeGet === "null"
        ? `Compensatory Request`
        : `Compensatory Request - ${employeeGet}`,
    );
  };

  const nullOption = { value: "null", label: "Select Employee Code" };
  const employeeOptions = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {PERMISSION_AUTHORITY ? (
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw   date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  <option value="null"> All Sub Companies</option>
                  {SubCompany.sort((a, b) => a.title - b.title).map(
                    (i, index) => (
                      <option value={i.id}>{i.title}</option>
                    ),
                  )}
                  ;
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            <div title=" Date Range" className="field-cont-div ">
              <DateRangePicker
                startDate={startdate}
                endDate={enddate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || formattedDatee);
                  setEndDate(end || formattedDate);
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer ? <div className="spinner-vsmall"></div> : <Employee />}

              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === employeeGet,
                  ) || nullOption
                }
                placeholder="Select Employee Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-16vw  "
                placeholder="Select Reporting head"
                type="text"
                value={rhname}
                onChange={(e) => setRhname(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw date-field"
                value={logDateEmpFilter}
                onChange={handleLogDateEmpChange}
              >
                <option value="null">No Filter</option>
                <option value="asc_empcode">Asc. Emp Code</option>
                <option value="desc_empcode">Desc. Emp Code</option>
                <option value="asc_name">Asc. Name</option>
                <option value="desc_name">Desc. Name</option>
                <option value="asc_date">Asc. Date</option>
                <option value="desc_date">Desc. Date</option>
              </select>

              <hr className="field-cont-hr" />
            </div>
          </div>

          <div className="table-heading-flex">
            <div className="btn-cont">
              <button
                className=" model-button-print"
                title="Download in Excel Format"
                onClick={handleDownloadExcel}
              >
                <DownloadIcon />
              </button>
            </div>
            {/* {(PORTAL_SETTINGS?.compoff_auto_apply && PORTAL_SETTINGS?.shortleave_auto_apply) && ( */}
            {(!PORTAL_SETTINGS?.compoff_auto_apply ||
              !PORTAL_SETTINGS?.shortleave_auto_apply) && (
                <div className="btn-cont" style={{ width: "max-content" }}>
                  <AddCompoffShortLeaveForm
                    getCompensatoryList={getCompensatoryList}
                    SUPER_ADMIN={SUPER_ADMIN}
                    SUB_COMPANIES={SUB_COMPANIES}
                    PERMISSION_HR_ADMIN={PERMISSION_HR_ADMIN}
                    PORTAL_SETTINGS={PORTAL_SETTINGS}
                  />
                </div>
              )}
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Compensatory Logs{" "}
            </div>
            {/* <div className="flex-row">
              <dir classname="accept  font-weight300font-size-text "><a href="">Accept</a></dir>
              <div classname="accept-rej   font-weight300 font-size-text "><a href="">Rejected</a></div>
            </div> */}
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                {/* <th className="align-left">
                  <input type="checkbox" onChange={(e) => {
                    if (e.target.checked) {
                      const ids = compensatoryList.map((data) => data.id);
                      setCheckedItems(ids);
                    } else {
                      setCheckedItems([]);
                    }
                  }} />
                </th> */}

                {/* <th className="align-center">Date</th> */}
                <th className="align-center">Empolyee Name</th>
                <th className="align-center">Date</th>
                <th className="align-center">In-Time</th>
                <th className="align-center">Out-Time</th>
                <th className="align-center">Working Hours</th>
                <th className="align-center">Compensatory Type</th>
                <th className="align-center">Reporting Head</th>
                <th className="align-center">Request Status</th>
                <th className="align-center ">Status</th>
                <th className="align-center ">Remark</th>
                {SUPER_ADMIN && <th className="align-center ">Action</th>}
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {filtered.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      {/* <td className="align-left">
                      <input
                        type="checkbox"
                        checked={checkedItems.indexOf(i.id) !== -1}
                        onChange={() => handleCheckboxChange(i.id)}
                      /></td> */}
                      {/* <td className="align-center">{i.date}</td> */}
                      <td className="align-center">
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.name, profilepic: i.profilepic }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode}-{i.name}
                        </p>
                      </td>
                      {/* <td className="align-center">{i.empcode}-{i.name}</td> */}
                      <td className="align-center">
                        {formattedDateLong(i.date)}
                      </td>
                      <td className="align-center">{i.in_time}</td>
                      <td className="align-center">{i.out_time}</td>
                      <td className="align-center">{i.work_duration}</td>
                      <td className="align-center text-capitalize">
                        {i.duration}{" "}
                        {i.duration === "short leave" ? "(0.25)" : "(1)"}
                      </td>
                      <td className="align-center">
                        <CustomImageModal customStyle>
                          {i.rh_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.rh_profilepic}`}
                              className="profile-img"
                              alt={i?.rh_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{
                                name: i.rh_name,
                                profilepic: i.rh_profilepic,
                              }}
                              customStyleforParent={"reqOutDuty-default-logo"}
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.rh_assigned}-{i.rh_name}
                        </p>
                      </td>
                      <td className="align-center">
                        {i.approval_flow_version === 0 ? "Legacy Request" : "-"}
                      </td>
                      <td className="align-center">
                        {i.approval_flow_version === 0 ? (
                          <span
                            request-status={i.rh_leave_status}
                            className="request-status align-center"
                          >
                            {i.rh_leave_status === "pending"
                              ? "Pending For Rh Approval ⌛"
                              : i.rh_leave_status === "rejected"
                                ? "Rh Rejected ✖, "
                                : "Rh Approved ✔, "}
                          </span>
                        ) : (
                          <ViewDynamicApprovalStatus
                            dynamic_approval={i?.dynamic_approval}
                          />
                        )}
                        {/* <br />
                      <span request-status={i.admin_leave_status} className="request-status align-center" >{(i.rh_leave_status === "rejected" && i.admin_leave_status === "rejected") ? "Admin Rejected ✖, " : (i.rh_leave_status === "approved" && i.admin_leave_status === "pending") ? "Pending For Admin Approval ⌛," : (i.rh_leave_status === "approved" && i.admin_leave_status === "rejected") ? "Admin Rejected ✖, " : (i.rh_leave_status === "approved" && i.admin_leave_status === "approved") ? "Admin Approved ✔, " : ""}</span> */}
                      </td>

                      <td className="table-body width-15vw align-center vertical-alignment-middle">
                        {i?.approval_flow_version === 0 ? (
                          i.reason || "-"
                        ) : (
                          <ViewDynamicApprovalRemarks
                            dynamic_approval={i?.dynamic_approval}
                          />
                        )}
                      </td>
                      {SUPER_ADMIN && (
                        <td className="align-right">
                          {(i.rh_leave_status === "pending" ||
                            i?.rh_leave_status === "rejected") && (
                              <div className="flex-row align-center width-5vw">
                                <DeleteCompoffShortLeaveForm
                                  i={i}
                                  getCompensatoryList={getCompensatoryList}
                                />
                              </div>
                            )}
                        </td>
                      )}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const HODCompensatoryLogTable = () => {
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [employeeList, setEmployeeList] = useState([]);

  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");
  const [selectedStatus, setSelectedStatus] = useState("null");
  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const selectedDivision = sessionStorage.getItem("company_id");
  const selectedDepartment = sessionStorage.getItem("department");

  // *********** Employee Details Api Start ***********
  const [compensatoryList, setCompensatoryList] = useState([]);

  const getEmpList = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbydepartment/${selectedDepartment}/${active}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  const getCompensatoryList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        // `${BASE_URL}/wfm/shortandcompoff/${fromdate}/${todate}/null/${selectedStatus}/${employeeGet}/${selectedDivision}/${active}/`
        `${BASE_URL}/wfm/shortleaveandcompoffbyhodfilter/${selectedDivision}/${selectedDepartment}/${fromdate}/${todate}/${employeeGet}/${active}/`,
      );
      setCompensatoryList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getCompensatoryList();
  }, [selectedDivision, employeeGet, fromdate, todate, active]);

  useEffect(() => {
    getEmpList();
  }, [selectedDivision, active]);

  const nullOption = { value: "null", label: "Select Employee Code" };
  const employeeOptions = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value || "null")}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value || "null")}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            {/* <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div> */}

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === employeeGet,
                  ) || nullOption
                }
                placeholder="Select Employee Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Compensatory Logs{" "}
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                {/* <th className="align-center">Date</th> */}
                <th className="align-center">Empolyee Name</th>
                <th className="align-center">Date</th>
                <th className="align-center">In-Time</th>
                <th className="align-center">Out-Time</th>
                <th className="align-center">Working Hours</th>
                <th className="align-center">Compensatory Type</th>
                <th className="align-center">Reporting Head</th>
                <th className="align-center">Status</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {compensatoryList
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">
                          <CustomImageModal customStyle>
                            {i.profilepic ? (
                              <img
                                src={`${IMAGE_URL}${i.profilepic}`}
                                alt="profile"
                                className="profile-img"
                              />
                            ) : (
                              <UserDefaultLogo
                                user={{
                                  name: i.name,
                                  profilepic: i.profilepic,
                                }}
                                customStyleforParent={
                                  "reqOutDuty-default-logo-dashboard"
                                }
                                customStyleforChild={"small-profile"}
                              />
                            )}
                          </CustomImageModal>
                          <p>
                            {i.empcode}-{i.name}
                          </p>
                        </td>
                        {/* <td className="align-center">{i.empcode}-{i.name}</td> */}
                        <td className="align-center">
                          {formattedDateLong(i.date)}
                        </td>
                        <td className="align-center">{i.in_time}</td>
                        <td className="align-center">{i.out_time}</td>
                        <td className="align-center">{i.work_duration}</td>
                        <td className="align-center text-capitalize">
                          {i.duration}
                        </td>
                        <td className="align-center">{i.rh_assigned}</td>
                        <td className="align-center">
                          <span
                            request-status={i.rh_leave_status}
                            className="request-status align-center"
                          >
                            {i.rh_leave_status === "pending"
                              ? "Pending For Rh Approval ⌛"
                              : i.rh_leave_status === "rejected"
                                ? "Rh Rejected ✖, "
                                : "Rh Approved ✔, "}
                          </span>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const LeavesChangeLogTable = () => {
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [employeeList, setEmployeeList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [selectedDepartment, setSelectedDepartment] = useState(`null`);
  const [active, setActive] = useState("active");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  // const year = today.getFullYear();
  // const month = today.getMonth() + 1;
  // const [monthh, setMonthh] = useState(`${month}`);
  // const [yearr, setYearr] = useState(`${year}`);

  const today = new Date();

  // Get the real current month and year
  // const currentMonth = (today.getMonth() + 1).toString();
  // const currentYear = today.getFullYear().toString();

  // const [startMonth, setStartMonth] = useState(currentMonth);
  // const [startYear, setStartYear] = useState(currentYear);

  // const [endMonth, setEndMonth] = useState(currentMonth);
  // const [endYear, setEndYear] = useState(currentYear);

  // const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  // const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  // const monthNames = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];

  const [startDate, setStartDate] = useState(`${formattedDatee}`);
  const [endDate, setEndDate] = useState(`${formattedDate}`);

  // *********** Employee Details Api Start ***********
  const [leaveLogList, setLeaveLogList] = useState([]);

  // ================= PAGINATION STATES =================
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const observerTarget = useRef(null);

  // --- ADDED: Table Reference for Excel Download ---
  const tableRef = useRef(null);

  // --- ADDED: Excel Download Handler ---
  const handleDownloadExcel = () => {
    downloadAsExcel(
      tableRef,
      "leave_logs",
      employeeGet === "null"
        ? `Employee Leave Logs`
        : `Employee Leave Logs - ${employeeGet}`
    );
  };

  const getFilterData = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);

      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedDivision}/${active}/`,
      );
      setDepartmentList(dep.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false);
    }
  };

  // const getLeaveLogList = async () => {
  //   setBuffering(true); //buffering logic // Start Buffering
  //   try {
  //     const res = await axios.get(
  //       // `${BASE_URL}/wfm/leave-balance-logs-filter/${selectedDivision}/${selectedDepartment}/${employeeGet}/${active}/`
  //       `${BASE_URL}/wfm/leave-balance-logs-filter/${selectedDivision}/${selectedDepartment}/${employeeGet}/${startMonth}/${startYear || "null"}/`,
  //     );
  //     setLeaveLogList(res.data);
  //   } catch (err) {
  //     handleErrorToast(err);
  //   } finally {
  //     setBuffering(false); //buffering logic // End Buffering
  //   }
  // };

  // ================= API CALL: FETCH & FILTER =================
  const getLeaveLogList = async (currentPage = 1, forceReset = false) => {
    if (currentPage === 1) {
      setBuffering(true);
    } else {
      setLoadingMore(true);
    }

    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/leave-balance-logs-with-pagination-filter/${selectedDivision}/${selectedDepartment}/${employeeGet}/${startDate}/${endDate}/?page=${currentPage}&page_size=50`
      );

      const fetchedResults = res.data.results || [];
      setTotalPages(res.data.total_pages || 1);

      if (currentPage === 1 || forceReset) {
        setLeaveLogList(fetchedResults);
      } else {
        setLeaveLogList((prev) => [...prev, ...fetchedResults]);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
      setLoadingMore(false);
    }
  };

  // *********** Employee Details Api End ***********

  // useEffect(() => {
  //   getLeaveLogList();
  // }, [
  //   selectedDivision,
  //   employeeGet,
  //   selectedDepartment,
  //   startMonth,
  //   startYear,
  // ]);

  // ================= FETCH NEXT PAGE =================
  useEffect(() => {
    if (page > 1) {
      getLeaveLogList(page, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  // ================= RESET PAGE ON FILTER CHANGE =================
  useEffect(() => {
    setPage(1);
    getLeaveLogList(1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDivision, employeeGet, selectedDepartment, startDate, endDate]);

  useEffect(() => {
    getFilterData();
  }, [selectedDivision, active]);

  // ================= INFINITE SCROLL OBSERVER =================
  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];
      if (
        target.isIntersecting &&
        !buffer &&
        !loadingMore &&
        page < totalPages
      ) {
        setPage((prevPage) => prevPage + 1);
      }
    },
    [buffer, loadingMore, page, totalPages]
  );

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "20px",
      threshold: 0,
    };
    const observer = new IntersectionObserver(handleObserver, option);
    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }
    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current);
      }
    };
  }, [handleObserver]);

  const nullOption = { value: "null", label: "Select Employee Code" };
  const employeeOptions = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {SUPER_ADMIN ? (
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw   date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  <option value="">All Companies</option>
                  {SUB_COMPANIES.sort((a, b) => a.title - b.title).map(
                    (i, index) => (
                      <option value={i.id}>{i.title}</option>
                    ),
                  )}
                  ;
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            {/* <div className="field-cont-div">
              <input
                type="number"
                min={2000}
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-5vw date-field"
              />
              <hr className="field-cont-hr" />
            </div> */}
            {/* <div className="field-cont-div">
              <Calender />
              <select
                className="attendance-input-field width-10vw date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                <option value="null">All Months</option>
                {monthNames.map((i, index) => (
                  <option key={index} value={index + 1}>{i}</option>
                ))}
              </select>
              <hr className="field-cont-hr" />
            </div> */}

            {/* <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div> */}

            {/* ================= DATE RANGE PICKER ================= */}
            <div title="Date Range" className="field-cont-div ">
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || formattedDatee);
                  setEndDate(end || formattedDate);
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer1 ? (
                <div className="spinner-vsmall"></div>
              ) : (
                <CircularGrid />
              )}
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
              >
                <option value="null">All Department</option>
                {departmentList
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === employeeGet,
                  ) || nullOption
                }
                placeholder="Select Employee Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-15vw"
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>

          {/* --- ADDED: Download Button --- */}
            <div className="btn-cont">
              <button
                className="model-button-print"
                title="Download in Excel Format"
                onClick={handleDownloadExcel}
              >
                <DownloadIcon />
              </button>
            </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Employee Leave Logs{" "}
            </div>
          </div>
          <table ref={tableRef} className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Employee Name</th>
                <th className="align-center">Date-Time</th>
                <th className="align-center">Leave Type</th>
                <th className="align-center">Balance Before</th>
                <th className="align-center">Leaves Affected</th>
                <th className="align-center">Balance After</th>
                <th className="align-center width-20vw">Description</th>
              </tr>
            </thead>
            {/* {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {leaveLogList
                  .sort((a, b) => new Date(b.date_time) - new Date(a.date_time))
                  .map((log, index) => {
                    // 1. Prioritize the direct API properties first
                    let balanceBefore = log.balance_before;
                    let balanceAfter = log.balance_after;
                    let leavesAffected = log.leave_affected;

                    // 2. Safe fallback for older logs (like June) where properties are null
                    if (balanceBefore === null || balanceAfter === null) {
                      if (log.description?.includes("decremented") || log.description?.includes("incremented")) {
                        const descParts = log.description.split(" ");
                        balanceBefore = parseFloat(descParts[4]);
                        balanceAfter = parseFloat(descParts[6]);
                        leavesAffected = Math.abs(balanceAfter - balanceBefore).toFixed(2);
                      } else {
                        // Catch-all to prevent NaN if a new description format appears with null balances
                        balanceBefore = "-";
                        balanceAfter = "-";
                        leavesAffected = "-";
                      }
                    } else {
                      // Ensure decimal formatting matches the fallback UI expectation
                      leavesAffected = parseFloat(leavesAffected).toFixed(2);
                    }
                    return (
                      <React.Fragment key={log.id}>
                        <tr className="tr-border-bottom">
                          <td colSpan="8"></td>
                        </tr>
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">
                            <CustomImageModal customStyle>
                              {log.profilepic ? (
                                <img
                                  src={`${IMAGE_URL}${log.profilepic}`}
                                  alt="profile"
                                  className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{
                                    name: log.emp_name,
                                    profilepic: log.profilepic,
                                  }}
                                  customStyleforParent={
                                    "reqOutDuty-default-logo-dashboard"
                                  }
                                  customStyleforChild={"small-profile"}
                                />
                              )}
                            </CustomImageModal>
                            <p>
                              {log.emp_code}-{log.emp_name}
                            </p>
                          </td>
                          <td className="align-center">
                            {formatDateTime(log.date_time).longdatetime}
                          </td>
                          <td className="align-center text-capitalize">
                            {log.leave_type}
                          </td>
                          <td className="align-center">{balanceBefore}</td>
                          <td
                            className="align-center"
                            style={{
                              color: log.action === "add" ? "green" : "red",
                            }}
                          >
                            {log.action === "add" ? "+" : "-"}
                            {leavesAffected}
                          </td>
                          <td className="align-center">{balanceAfter}</td>
                          <td className="align-center">{log.description}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
              </tbody>
            )} */}
            {buffer && page === 1 ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {leaveLogList
                  .sort((a, b) => new Date(b.date_time) - new Date(a.date_time))
                  .map((log, index) => {
                    let balanceBefore = log.balance_before;
                    let balanceAfter = log.balance_after;
                    let leavesAffected = log.leave_affected;

                    if (balanceBefore === null || balanceAfter === null) {
                      if (
                        log.description?.includes("decremented") ||
                        log.description?.includes("incremented")
                      ) {
                        const descParts = log.description.split(" ");
                        balanceBefore = parseFloat(descParts[4]);
                        balanceAfter = parseFloat(descParts[6]);
                        leavesAffected = Math.abs(
                          balanceAfter - balanceBefore
                        ).toFixed(2);
                      } else {
                        balanceBefore = "-";
                        balanceAfter = "-";
                        leavesAffected = "-";
                      }
                    } else {
                      leavesAffected = parseFloat(leavesAffected).toFixed(2);
                    }
                    return (
                      <React.Fragment key={log.id}>
                        <tr className="tr-border-bottom">
                          <td colSpan="8"></td>
                        </tr>
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">
                            <CustomImageModal customStyle>
                              {log.profilepic ? (
                                <img
                                  src={`${IMAGE_URL}${log.profilepic}`}
                                  alt="profile"
                                  className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{
                                    name: log.emp_name,
                                    profilepic: log.profilepic,
                                  }}
                                  customStyleforParent={
                                    "reqOutDuty-default-logo-dashboard"
                                  }
                                  customStyleforChild={"small-profile"}
                                />
                              )}
                            </CustomImageModal>
                            <p>
                              {log.emp_code}-{log.emp_name}
                            </p>
                          </td>
                          <td className="align-center">
                            {formatDateTime(log.date_time).longdatetime}
                          </td>
                          <td className="align-center text-capitalize">
                            {log.leave_type}
                          </td>
                          <td className="align-center">{balanceBefore}</td>
                          <td
                            className="align-center"
                            style={{
                              color: log.action === "add" ? "green" : "red",
                            }}
                          >
                            {log.action === "add" ? "+" : "-"}
                            {leavesAffected}
                          </td>
                          <td className="align-center">{balanceAfter}</td>
                          <td className="align-center">{log.description}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  
                  {/* ================= LOADING MORE INDICATOR / OBSERVER TARGET ================= */}
                  {page < totalPages && (
                    <tr ref={observerTarget}>
                      <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                        {loadingMore ? (
                          <div className="spinner"></div>
                        ) : (
                          "Scroll for more"
                        )}
                      </td>
                    </tr>
                  )}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const HODLeavesLogTable = () => {
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [employeeList, setEmployeeList] = useState([]);

  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const selectedDivision = sessionStorage.getItem("company_id");
  const selectedDepartment = sessionStorage.getItem("department");

  // const today = new Date();
  // const year = today.getFullYear();
  // const month = today.getMonth() + 1;
  // const [monthh, setMonthh] = useState(`${month}`);
  // const [yearr, setYearr] = useState(`${year}`);

  const today = new Date();
  // today.setDate(today.getDate() - 1);

  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();

  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);

  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // *********** Employee Details Api Start ***********
  const [leaveLogList, setLeaveLogList] = useState([]);

  const getEmpList = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");

      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false);
    }
  };

  const getLeaveLogList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/leave-balance-logs-filter/${selectedDivision}/${selectedDepartment}/${employeeGet}/${startMonth}/${startYear || "null"}/`,
      );
      setLeaveLogList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getLeaveLogList();
  }, [employeeGet, startMonth, startYear]);

  useEffect(() => {
    getEmpList();
  }, [selectedDivision, active]);

  const nullOption = { value: "null", label: "Select Employee Code" };
  const employeeOptions = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            {/* <div className="field-cont-div">
              <Calender />
              <select
                className="attendance-input-field width-10vw date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                <option value="null">All Months</option>
                {monthNames.map((i, index) => (
                  <option key={index} value={index + 1}>{i}</option>
                ))}
              </select>
              <hr className="field-cont-hr" />
            </div> */}
            {/* <div className="field-cont-div">
              <input
                type="number"
                min={2000}
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-5vw date-field"
              />
              <hr className="field-cont-hr" />
            </div> */}

            <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === employeeGet,
                  ) || nullOption
                }
                placeholder="Select Employee Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>
          </div>

          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Employee Leave Logs{" "}
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Employee Name</th>
                <th className="align-center">Date-Time</th>
                <th className="align-center">Leave Type</th>
                <th className="align-center">Balance Before</th>
                <th className="align-center">Leaves Affected</th>
                <th className="align-center">Balance After</th>
                <th className="align-center width-20vw">Description</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {leaveLogList
                  .sort((a, b) => new Date(b.date_time) - new Date(a.date_time))
                  .map((log, index) => {
                        // 1. Prioritize the direct API properties first
                        let balanceBefore = log.balance_before;
                        let balanceAfter = log.balance_after;
                        let leavesAffected = log.leave_affected;

                        // 2. Safe fallback for older logs (like June) where properties are null
                        if (balanceBefore === null || balanceAfter === null) {
                          if (log.description?.includes("decremented") || log.description?.includes("incremented")) {
                            const descParts = log.description.split(" ");
                            balanceBefore = parseFloat(descParts[4]);
                            balanceAfter = parseFloat(descParts[6]);
                            leavesAffected = Math.abs(balanceAfter - balanceBefore).toFixed(2);
                          } else {
                            // Catch-all to prevent NaN if a new description format appears with null balances
                            balanceBefore = "-";
                            balanceAfter = "-";
                            leavesAffected = "-";
                          }
                        } else {
                          // Ensure decimal formatting matches the fallback UI expectation
                          leavesAffected = parseFloat(leavesAffected).toFixed(2);
                        }
                    return (
                      <React.Fragment key={log.id}>
                        <tr className="tr-border-bottom">
                          <td colSpan="8"></td>
                        </tr>
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">
                            <CustomImageModal customStyle>
                              {log.profilepic ? (
                                <img
                                  src={`${IMAGE_URL}${log.profilepic}`}
                                  alt="profile"
                                  className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{
                                    name: log.emp_name,
                                    profilepic: log.profilepic,
                                  }}
                                  customStyleforParent={
                                    "reqOutDuty-default-logo-dashboard"
                                  }
                                  customStyleforChild={"small-profile"}
                                />
                              )}
                            </CustomImageModal>
                            <p>
                              {log.emp_code}-{log.emp_name}
                            </p>
                          </td>
                          <td className="align-center">
                            {formatDateTime(log.date_time).longdatetime}
                          </td>
                          <td className="align-center text-capitalize">
                            {log.leave_type}
                          </td>
                          <td className="align-center">{balanceBefore}</td>
                          <td
                            className="align-center"
                            style={{
                              color: log.action === "add" ? "green" : "red",
                            }}
                          >
                            {log.action === "add" ? "+" : "-"}
                            {leavesAffected}
                          </td>
                          <td className="align-center">{balanceAfter}</td>
                          <td className="align-center">{log.description}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RHLeaveApprovalDelayLogTable = () => {
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [buffer, setBuffering] = useState(true);
  const [buffer1, setBuffering1] = useState(true);
  const [rhList, setRHList] = useState([]);
  const [selectedRh, setSelectedRh] = useState("null");
  const [active, setActive] = useState("active");
  const [selectedRHStatus, setSelectedRHStatus] = useState("null");
  const [selectedAdminStatus, setSelectedAdminStatus] = useState("null");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  // const today = new Date();
  // const year = today.getFullYear();
  // const month = today.getMonth() + 1;
  // const [monthh, setMonthh] = useState(`${month}`);
  // const [yearr, setYearr] = useState(`${year}`);

  const today = new Date();

  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();

  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);

  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // *********** Employee Details Api Start ***********
  const [leaveDelayLogList, setLeaveDelaysLogList] = useState([]);

  const getRhList = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/rhlistactive/${selectedDivision}/${active}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setRHList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  const getLeaveDelayLogList = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/reporting-head-leave-delay-report-filtered/${selectedDivision}/${active}/${startMonth}/${startYear}/${selectedRh}/${selectedRHStatus}/${selectedAdminStatus}/`,
      );
      setLeaveDelaysLogList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getRhList();
  }, [selectedDivision, active]);

  useEffect(() => {
    getLeaveDelayLogList();
  }, [
    selectedDivision,
    active,
    startMonth,
    startYear,
    selectedRHStatus,
    selectedAdminStatus,
    selectedRh,
  ]);

  const nullOption = { value: "null", label: "Select Reporting Head" };
  const employeeOptions = rhList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedRh(selectedOption.value);
    } else {
      setSelectedRh(null);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500 font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {SUPER_ADMIN && (
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  {/* <option value="null">All Companies</option> */}
                  {SUB_COMPANIES.sort((a, b) => a.title - b.title).map(
                    (i, index) => (
                      <option value={i.id}>{i.title}</option>
                    ),
                  )}
                </select>
                <hr className="field-cont-hr" />
              </div>
            )}

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
            {/* 
            <div className="field-cont-div">
              <input
                type="number"
                min={2000}
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-5vw date-field"
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Calender />
              <select
                className="attendance-input-field width-10vw date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                <option value="0">All Months</option>
                {monthNames.map((i, index) => (
                  <option key={index} value={index + 1}>{i}</option>
                ))}
              </select>
              <hr className="field-cont-hr" />
            </div> */}
            <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === selectedRHStatus,
                  ) || nullOption
                }
                placeholder="Select Reporting Head Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title="" className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedRHStatus}
                onChange={(e) => setSelectedRHStatus(e.target.value)}
              >
                <option value="null">All RH Requests</option>
                <option value="pending">RH Pending Leaves</option>
                <option value="approved">RH Rectified Leaves</option>
                <option value="rejected">RH Rejected Leaves</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div title="" className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedAdminStatus}
                onChange={(e) => setSelectedAdminStatus(e.target.value)}
              >
                <option value="null">All Admin Requests</option>
                <option value="pending">Admin Pending Leaves</option>
                <option value="approved">Admin Rectified Leaves</option>
                <option value="rejected">Admin Rejected Leaves</option>
              </select>
              {/* <hr className="field-cont-hr" /> */}
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Reporting Head Leave Approval Delays
            </div>
          </div>

          {buffer ? (
            <div className="spinner"></div>
          ) : (
            leaveDelayLogList.map((report, reportIndex) => (
              <div key={reportIndex} className="report-section">
                <div className="report-header">
                  <div className="report-heading">
                    <h5>
                      {report.rh_assigned_details.emp_name} (
                      {report.rh_assigned_details.emp_code}) -{" "}
                      {report.rh_assigned_details.designation_name}
                    </h5>
                    <p>
                      Delayed Approvals: {report.delayed_count} | Not Approved:{" "}
                      {report.notapproved_count}
                    </p>
                  </div>
                </div>

                <table className="table-css">
                  <thead>
                    <tr className="custom-table-head-tr-0P">
                      <th className="align-left">Sr.no</th>
                      <th className="align-center">Employee</th>
                      <th className="align-center">Leave Dates</th>
                      <th className="align-center">Leave Type</th>
                      <th className="align-center">Duration</th>
                      <th className="align-center">Applied On</th>
                      <th className="align-center">RH Updated On</th>
                      <th className="align-center">RH Status</th>
                      <th className="align-center">
                        Final Rectification Status
                      </th>
                      <th className="align-center">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Delayed Leaves */}
                    {report.delayed_request_details.map((leave, index) => (
                      <tr
                        key={`delayed-${index}`}
                        className="custom-table-head-td delayed-row"
                      >
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">
                          {leave.empcode}-{leave.name}
                        </td>
                        <td className="align-center">
                          {formattedDateLong(leave.date)}
                          {leave.end_date !== leave.date &&
                            ` to ${formattedDateLong(leave.end_date)}`}
                        </td>
                        <td className="align-center text-capitalize">
                          {leave.leave_type}
                        </td>
                        <td className="align-center">{leave.leave_Duration}</td>
                        <td className="align-center">
                          {formatDateTime(leave.apply_datetime).longdatetime}
                        </td>
                        <td className="align-center">
                          {leave.rh_update_datetime ? (
                            <>
                              <span
                                request-status={leave.rh_leave_status}
                                className="request-status text-capitalize"
                              >
                                {leave.rh_leave_status}
                              </span>
                              <br />
                              on
                              <br />
                              <span>
                                {
                                  formatDateTime(leave.rh_update_datetime)
                                    .longdatetime
                                }
                              </span>
                            </>
                          ) : (
                            `No Action`
                          )}
                        </td>
                        <td className="align-center">
                          <span className="delayed">
                            Delayed by {leave.delay_days} days
                          </span>
                          <br />
                          <span className="delayed">
                            After {leave.approval_limit} days approval limit
                          </span>
                        </td>
                        <td
                          request-status={leave.admin_leave_status}
                          className="align-center request-status text-capitalize"
                        >
                          {leave.admin_leave_status}
                        </td>
                        <td className="align-center">{leave.remarks || "-"}</td>
                      </tr>
                    ))}

                    {/* Not Approved Leaves */}
                    {report.notapproved_request_details.map((leave, index) => {
                      const applyDate = new Date(leave.apply_datetime);
                      const currentDate = new Date();
                      const timeDiff = currentDate - applyDate;
                      const daysDiff = Math.floor(
                        timeDiff / (1000 * 60 * 60 * 24),
                      );
                      const isWithinLimit = daysDiff <= leave.approval_limit;
                      const exceededDays = daysDiff - leave.approval_limit;
                      const remainingDays = leave.approval_limit - daysDiff;
                      return (
                        <tr
                          key={`notapproved-${index}`}
                          className={`custom-table-head-td ${isWithinLimit ? "pending-within-limit-row" : "notapproved-exceeded-row"}`}
                        >
                          <td className="align-left">
                            {report.delayed_request_details.length + index + 1}
                          </td>
                          <td className="align-center">
                            {leave.empcode}-{leave.name}
                          </td>
                          <td className="align-center">
                            {formattedDateLong(leave.date)}
                            {leave.end_date !== leave.date &&
                              ` to ${formattedDateLong(leave.end_date)}`}
                          </td>
                          <td className="align-center text-capitalize">
                            {leave.leave_type}
                          </td>
                          <td className="align-center">
                            {leave.leave_Duration}
                          </td>
                          <td className="align-center">
                            {formatDateTime(leave.apply_datetime).longdatetime}
                          </td>
                          <td className="align-center">
                            {leave.rh_update_datetime ? (
                              <>
                                <span
                                  request-status={leave.rh_leave_status}
                                  className="request-status text-capitalize"
                                >
                                  {leave.rh_leave_status}
                                </span>
                                <br />
                                on
                                <br />
                                <span>
                                  {
                                    formatDateTime(leave.rh_update_datetime)
                                      .longdatetime
                                  }
                                </span>
                              </>
                            ) : (
                              `No Action`
                            )}
                          </td>
                          <td className="align-center">
                            <span
                              className={`${isWithinLimit
                                  ? "pending-within-limit"
                                  : "notapproved-exceeded"
                                }`}
                            >
                              {leave.admin_leave_status === "pending"
                                ? isWithinLimit
                                  ? "Approval Pending (Within Limit)"
                                  : "Not Approved (Exceeded Limit)"
                                : ""}
                            </span>
                            <br />
                            {isWithinLimit &&
                              leave.admin_leave_status == "pending" ? (
                              <>
                                <span className="pending-within-limit">
                                  {remainingDays > 0
                                    ? `${remainingDays} days remaining`
                                    : "Last day to approve"}
                                </span>
                              </>
                            ) : (
                              <>
                                {leave.rh_update_datetime &&
                                  leave.hr_update_datetime &&
                                  leave.rh_update_datetime ===
                                  leave.hr_update_datetime ? (
                                  <span className="notapproved-exceeded">
                                    Direct Rectification
                                  </span>
                                ) : (
                                  <span className="notapproved-exceeded">
                                    exceeded by {exceededDays} days
                                  </span>
                                )}
                              </>
                            )}
                          </td>
                          <td
                            request-status={leave.admin_leave_status}
                            className="align-center request-status text-capitalize"
                          >
                            {leave.admin_leave_status}
                          </td>
                          <td className="align-center">
                            {leave.remarks || "-"}
                          </td>
                        </tr>
                      );
                    })}
                    <br />
                  </tbody>
                </table>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

const RHOutDutyApprovalDelayLogTable = () => {
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [buffer, setBuffering] = useState(true);
  const [buffer1, setBuffering1] = useState(true);
  const [rhList, setRHList] = useState([]);
  const [selectedRh, setSelectedRh] = useState("null");
  const [active, setActive] = useState("active");
  const [selectedRHStatus, setSelectedRHStatus] = useState("null");
  const [selectedAdminStatus, setSelectedAdminStatus] = useState("null");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  // const today = new Date();
  // const year = today.getFullYear();
  // const month = today.getMonth() + 1;
  // const [monthh, setMonthh] = useState(`${month}`);
  // const [yearr, setYearr] = useState(`${year}`);

  const today = new Date();
  // today.setDate(today.getDate() - 1);

  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();

  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);

  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // *********** Employee Details Api Start ***********
  const [odDelayLogList, setODDelaysLogList] = useState([]);

  const getRhList = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/rhlistactive/${selectedDivision}/${active}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setRHList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false); //buffering logic // End Buffering
    }
  };

  const getODDelayLogList = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/reporting-head-od-delay-report-filtered/${selectedDivision}/${active}/${startMonth}/${startYear}/${selectedRh}/${selectedRHStatus}/${selectedAdminStatus}/`,
      );
      setODDelaysLogList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getRhList();
  }, [selectedDivision, active]);

  useEffect(() => {
    getODDelayLogList();
  }, [
    selectedDivision,
    active,
    startMonth,
    startYear,
    selectedRHStatus,
    selectedAdminStatus,
    selectedRh,
  ]);

  const nullOption = { value: "null", label: "Select Reporting Head" };
  const employeeOptions = rhList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedRh(selectedOption.value);
    } else {
      setSelectedRh(null);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500 font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {SUPER_ADMIN && (
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  <option value="">All Companies</option>
                  {SUB_COMPANIES.sort((a, b) => a.title - b.title).map(
                    (i, index) => (
                      <option value={i.id}>{i.title}</option>
                    ),
                  )}
                </select>
                <hr className="field-cont-hr" />
              </div>
            )}

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />

              {/* <input
                type="number"
                min={2000}
                maxLength={4}
                value={yearr}
                onChange={(e) => setYearr(e.target.value)}
                className="attendance-input-field width-5vw date-field"
              />
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Calender />
              <select
                className="attendance-input-field width-10vw date-field"
                type="text"
                value={monthh}
                onChange={(e) => setMonthh(e.target.value)}
              >
                <option value="0">All Months</option>
                {monthNames.map((i, index) => (
                  <option key={index} value={index + 1}>{i}</option>
                ))}
              </select>
              <hr className="field-cont-hr" /> */}
            </div>

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
              <Select
                options={[nullOption, ...employeeOptions]}
                value={
                  employeeOptions.find(
                    (option) => option.value === selectedRHStatus,
                  ) || nullOption
                }
                placeholder="Select Reporting Head Code"
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title="" className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedRHStatus}
                onChange={(e) => setSelectedRHStatus(e.target.value)}
              >
                <option value="null">All OutDutys Requests</option>
                <option value="pending">RH Pending OutDutys</option>
                <option value="approved">RH Rectified OutDutys</option>
                <option value="rejected">RH Rejected OutDutys</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div title="" className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={selectedAdminStatus}
                onChange={(e) => setSelectedAdminStatus(e.target.value)}
              >
                <option value="null">All OutDutys Requests</option>
                <option value="pending">Admin Pending OutDutys</option>
                <option value="approved">Admin Rectified OutDutys</option>
                <option value="rejected">Admin Rejected OutDutys</option>
              </select>
              {/* <hr className="field-cont-hr" /> */}
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Reporting Head OutDutys Approval Delays
            </div>
          </div>

          {buffer ? (
            <div className="spinner"></div>
          ) : (
            odDelayLogList.map((report, reportIndex) => (
              <div key={reportIndex} className="report-section">
                <div className="report-header">
                  <div className="report-heading">
                    <h5>
                      {report.rh_assigned_details.emp_name} (
                      {report.rh_assigned_details.emp_code}) -{" "}
                      {report.rh_assigned_details.designation_name}
                    </h5>
                    <p>
                      Delayed Approvals: {report.delayed_count} | Not Approved:{" "}
                      {report.notapproved_count}
                    </p>
                  </div>
                </div>

                <table className="table-css">
                  <thead>
                    <tr className="custom-table-head-tr-0P">
                      <th className="align-left">Sr.no</th>
                      <th className="align-center">Employee</th>
                      <th className="align-center">Out Duty Dates</th>
                      <th className="align-center">Duration</th>
                      <th className="align-center">Applied On</th>
                      <th className="align-center">RH Updated On</th>
                      <th className="align-center">RH Status</th>
                      <th className="align-center">
                        Final Rectification Status
                      </th>
                      <th className="align-center">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Delayed OutDutys */}
                    {report.delayed_request_details.map((od, index) => (
                      <tr
                        key={`delayed-${index}`}
                        className="custom-table-head-td delayed-row"
                      >
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">
                          {od.empcode}-{od.name}
                        </td>
                        <td className="align-center">
                          {formattedDateLong(od.date)}
                          {od.end_date !== od.date &&
                            ` to ${formattedDateLong(od.end_date)}`}
                        </td>
                        <td className="align-center">{od.outduty_Duration}</td>
                        <td className="align-center">
                          {formatDateTime(od.apply_datetime).longdatetime}
                        </td>
                        <td className="align-center">
                          {od.rh_update_datetime ? (
                            <>
                              <span
                                request-status={od.rh_leave_status}
                                className="request-status text-capitalize"
                              >
                                {od.rh_leave_status}
                              </span>
                              <br />
                              on
                              <br />
                              <span>
                                {
                                  formatDateTime(od.rh_update_datetime)
                                    .longdatetime
                                }
                              </span>
                            </>
                          ) : (
                            `No Action`
                          )}
                        </td>
                        <td className="align-center">
                          <span className="delayed">
                            Delayed by {od.delay_days} days
                          </span>
                          <br />
                          <span className="delayed">
                            After {od.approval_limit} days approval limit
                          </span>
                        </td>
                        <td
                          request-status={od.admin_leave_status}
                          className="align-center request-status text-capitalize"
                        >
                          {od.admin_leave_status}
                        </td>
                        <td className="align-center">{od.remarks || "-"}</td>
                      </tr>
                    ))}

                    {/* Not Approved OutDutys */}
                    {report.notapproved_request_details.map((od, index) => {
                      const applyDate = new Date(od.apply_datetime);
                      const currentDate = new Date();
                      const timeDiff = currentDate - applyDate;
                      const daysDiff = Math.floor(
                        timeDiff / (1000 * 60 * 60 * 24),
                      );
                      const isWithinLimit = daysDiff <= od.approval_limit;
                      const exceededDays = daysDiff - od.approval_limit;
                      const remainingDays = od.approval_limit - daysDiff;
                      return (
                        <tr
                          key={`notapproved-${index}`}
                          className={`custom-table-head-td ${isWithinLimit ? "pending-within-limit-row" : "notapproved-exceeded-row"}`}
                        >
                          <td className="align-left">
                            {report.delayed_request_details.length + index + 1}
                          </td>
                          <td className="align-center">
                            {od.empcode}-{od.name}
                          </td>
                          <td className="align-center">
                            {formattedDateLong(od.date)}
                            {od.end_date !== od.date &&
                              ` to ${formattedDateLong(od.end_date)}`}
                          </td>
                          <td className="align-center">
                            {od.outduty_Duration}
                          </td>
                          <td className="align-center">
                            {formatDateTime(od.apply_datetime).longdatetime}
                          </td>
                          <td className="align-center">
                            {od.rh_update_datetime ? (
                              <>
                                <span
                                  request-status={od.rh_leave_status}
                                  className="request-status text-capitalize"
                                >
                                  {od.rh_leave_status}
                                </span>
                                <br />
                                on
                                <br />
                                <span>
                                  {
                                    formatDateTime(od.rh_update_datetime)
                                      .longdatetime
                                  }
                                </span>
                              </>
                            ) : (
                              `No Action`
                            )}
                          </td>
                          <td className="align-center">
                            <span
                              className={`${isWithinLimit ? "pending-within-limit" : "notapproved-exceeded"}`}
                            >
                              {od.admin_leave_status === "pending"
                                ? isWithinLimit
                                  ? "Approval Pending (Within Limit)"
                                  : "Not Approved (Exceeded Limit)"
                                : ""}
                            </span>
                            <br />
                            {isWithinLimit &&
                              od.admin_leave_status == "pending" ? (
                              <>
                                <span className="pending-within-limit">
                                  {remainingDays > 0
                                    ? `${remainingDays} days remaining`
                                    : "Last day to approve"}
                                </span>
                              </>
                            ) : (
                              <>
                                {od.rh_update_datetime &&
                                  od.hr_update_datetime &&
                                  od.rh_update_datetime ===
                                  od.hr_update_datetime ? (
                                  <span className="notapproved-exceeded">
                                    Direct Rectification
                                  </span>
                                ) : (
                                  <span className="notapproved-exceeded">
                                    exceeded by {exceededDays} days
                                  </span>
                                )}
                              </>
                            )}
                          </td>
                          <td
                            request-status={od.admin_leave_status}
                            className="align-center request-status text-capitalize"
                          >
                            {od.admin_leave_status}
                          </td>
                          <td className="align-center">{od.remarks || "-"}</td>
                        </tr>
                      );
                    })}
                    <br />
                  </tbody>
                </table>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

const HRNotificationLogTable = () => {
  const { PERMISSION_AUTHORITY } = usePermission();
  // const [date, setDate] = useState();
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [employeeList, setEmployeeList] = useState([]);
  // const [date, setDate] = useState(`${formattedDate}`);
  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");
  const [selectedStatus, setSelectedStatus] = useState("null");
  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  // *********** Employee Details Api Start ***********
  const [leaveLogList, setLeaveLogList] = useState([]);

  const getEmpList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");

      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const getLeaveLogList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/shortandcompoff/${fromdate}/${todate}/null/${selectedStatus}/${employeeGet}/${selectedDivision}/${active}/`,
      );
      setLeaveLogList(res.data);
      // setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getLeaveLogList();
    getEmpList();
    getSubCompany();
  }, [employeeGet, fromdate, todate, selectedStatus, active, selectedDivision]);

  useEffect(() => { }, []);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {PERMISSION_AUTHORITY ? (
              <div className="field-cont-div">
                <Office />
                <select
                  className="attendance-input-field width-10vw   date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  <option value="">All Companies</option>
                  {SubCompany.sort((a, b) => a.title - b.title).map(
                    (i, index) => (
                      <option value={i.id}>{i.title}</option>
                    ),
                  )}
                  ;
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <CircularGrid />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="">Select Employee Code</option>
                {employeeList
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
            </div>
          </div>

          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Employee Notification Logs{" "}
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee Name</th>
                <th className="align-center">Date-Time</th>
                <th className="align-center">Leave Type</th>
                <th className="align-center">Balance Before</th>
                <th className="align-center">Leaves affected</th>
                <th className="align-center">Balance After</th>
                <th className="align-center width-20vw">Description</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {leaveLogList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        <img
                          className="profile-img"
                          src={
                            `${i.profilepic}`
                              ? `https://cipl-aimantra.s3.ap-south-1.amazonaws.com/${i.profilepic}`
                              : "https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                          }
                          alt="profilepic"
                        />
                        <p>
                          {i.empcode}-{i.name}
                        </p>
                      </td>
                      <td className="align-center">
                        {formattedDateLong(i.date)}-{i.in_time}
                      </td>
                      <td className="align-center text-capitalize">
                        {i.duration}
                      </td>
                      <td className="align-center">{i.out_time}</td>
                      <td className="align-center">{i.work_duration}</td>
                      <td className="align-center">{i.rh_assigned}</td>
                      <td className="align-center text-capitalize">
                        {i.duration}
                      </td>
                      {/* <td className="align-center">
                        <span
                          request-status={i.rh_leave_status}
                          className="request-status align-center"
                        >
                          {i.rh_leave_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_leave_status === "rejected"
                              ? "Rh Rejected ✖, "
                              : "Rh Approved ✔, "}
                        </span>
                      </td> */}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const HODNotificationLogTable = () => {
  // const [date, setDate] = useState();
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [employeeList, setEmployeeList] = useState([]);
  // const [date, setDate] = useState(`${formattedDate}`);
  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");
  const [selectedStatus, setSelectedStatus] = useState("null");
  const [employeeGet, setEmployeeGet] = useState("null");
  const [active, setActive] = useState("active");
  const selectedDivision = sessionStorage.getItem("company_id");

  // *********** Employee Details Api Start ***********
  const [leaveLogList, setLeaveLogList] = useState([]);

  const getEmpList = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");

      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const getLeaveLogList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/shortandcompoff/${fromdate}/${todate}/null/${selectedStatus}/${employeeGet}/${selectedDivision}/${active}/`,
      );
      setLeaveLogList(res.data);
      // setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // *********** Employee Details Api End ***********

  useEffect(() => {
    getLeaveLogList();
    getEmpList();
  }, [employeeGet, fromdate, todate, selectedStatus, active, selectedDivision]);

  useEffect(() => { }, []);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <CircularGrid />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="">Select Employee Code</option>
                {employeeList
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
            </div>
          </div>

          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Employee Notification Logs{" "}
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Empolyee Name</th>
                <th className="align-center">Date-Time</th>
                <th className="align-center">Leave Type</th>
                <th className="align-center">Balance Before</th>
                <th className="align-center">Leaves affected</th>
                <th className="align-center">Balance After</th>
                <th className="align-center width-20vw">Description</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {leaveLogList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.name, profilepic: i.profilepic }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode}-{i.name}
                        </p>
                      </td>
                      <td className="align-center">
                        {formattedDateLong(i.date)}-{i.in_time}
                      </td>
                      <td className="align-center text-capitalize">
                        {i.duration}
                      </td>
                      <td className="align-center">{i.out_time}</td>
                      <td className="align-center">{i.work_duration}</td>
                      <td className="align-center">{i.rh_assigned}</td>
                      <td className="align-center text-capitalize">
                        {i.duration}
                      </td>
                      {/* <td className="align-center">
                        <span
                          request-status={i.rh_leave_status}
                          className="request-status align-center"
                        >
                          {i.rh_leave_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_leave_status === "rejected"
                              ? "Rh Rejected ✖, "
                              : "Rh Approved ✔, "}
                        </span>
                      </td> */}
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestImpresttableHOD = () => {
  const { PERMISSION_ASSIGNED_ADMIN, PERMISSION_AUTHORITY } = usePermission();
  // *********** Employee Details Api Start ***********

  const [buffer, setBuffering] = useState(true); //buffering logic

  const [allemployee, setAllemployee] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("pending");

  const [employeeGet, setEmployeeGet] = useState("null");
  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");

  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  const [selectedDepartment, setDepartment] = useState(
    // `${sessionStorage.getItem("department")}`
    `null`,
  );

  const [active, setActive] = useState("active");

  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  //! ******************************API start***************************//
  const getimprestname = async () => {
    try {
      setBuffering(true); //buffering logic // Start Buffering
      const res = await axios.get(
        // `${BASE_URL}/wfm/imprestbyadmin/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${selectedDivision}/${active}/`
        `${BASE_URL}/wfm/imprestbyhodlte7000/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${selectedDepartment}/${selectedDivision}/${active}/`,
      );
      setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getSubCompany();
    getimprestname();
  }, [fromdate, todate, selectedStatus, employeeGet, selectedDivision]);

  const getEmpcode = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllemployee(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getEmpcode();
  }, [active, selectedDivision]);
  //! *********** Employee Details Api End ***********

  const options = allemployee
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: "null", label: "Select Employee Code" };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      // Set selected employee code(s)
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null); // Clear selection
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Employee />
              <Select
                className="attendance-input-field width-15vw"
                width="200px"
                options={[nullOption, ...options]} // Include "null" option at the beginning
                placeholder="Select Employee Code"
                value={
                  options.find((option) => option.value === employeeGet) ||
                  nullOption
                } // Ensure the correct option is selected
                onChange={handleChange}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    color: "#707070",
                    outline: "none",
                    border: "none",
                    padding: "0.6rem 0.5rem",
                    textTransform: "capitalize",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: "#707070",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: "#707070",
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    filter: "invert(50%)",
                    cursor: "pointer",
                    left: "9.5rem",
                    width: "20px",
                    height: "20px",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // Ensure dropdown menu appears above other elements
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    color: state.isSelected ? "#2576bc" : "#707070",
                    backgroundColor: state.isSelected
                      ? "rgba(37,118,188,0.1)"
                      : "white",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#2576bc",
                      color: "white",
                    },
                  }),
                }}
              />
              {/* <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="null">Select Employee Code </option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select> */}
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="null"> All Sub Companies</option>
                {SubCompany.sort((a, b) => a.title - b.title).map(
                  (i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ),
                )}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new scroll-container-table">
          <div className="table-heading-flex">
            {/* <div className="repo-heading font-weight500    font-size-heading">Imprest </div> */}
          </div>
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-new">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Imprest Date</th>
                <th className="table-heading">Dates</th>
                <th className="table-heading width-5vw">Imprest Name</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Total Amount
                </th>
                <th className="table-heading">Days And Employee Count</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Person Name
                </th>
                <th className="table-heading">Remarks</th>
                <th className="table-heading">Status</th>
                <th
                  className="table-heading width-5vw"
                  style={{ textAlign: "center" }}
                >
                  Action
                </th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {outdutyname
                  .sort((a, b) => {
                    const dateA = a.admin_update_datetime
                      ? new Date(a.admin_update_datetime)
                      : null;
                    const dateB = b.admin_update_datetime
                      ? new Date(b.admin_update_datetime)
                      : null;
                    if (dateA && dateB) {
                      return dateB - dateA;
                    }
                    if (dateA) return -1;
                    if (dateB) return 1;
                    return 0;
                  })
                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr
                        className="custom-table-head-td"
                        title={`Admin Status : ${i.admin_leave_status}`}
                      >
                        <td className="table-body">{index + 1}</td>
                        <td className="table-body">
                          {i.project_id ? (
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="table-body">Project Code</td>
                                  <td
                                    className="table-body"
                                    style={{ padding: "0px 4px" }}
                                  >
                                    :
                                  </td>
                                  <td className="align-right word-wrap-20vw">
                                    {i.ref_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body text-left">
                                    Project Name
                                  </td>
                                  <td
                                    className="table-body"
                                    style={{ padding: "0px 4px" }}
                                  >
                                    :
                                  </td>
                                  <td className="align-right word-wrap-20vw">
                                    {i.ref_project_name}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            <div className="align-center justify-center">
                              - No Project Referenced -
                            </div>
                          )}
                        </td>

                        <td
                          className="table-body"
                          style={{ textAlign: "center" }}
                        >
                          <CustomImageModal customStyle>
                            {i.profilepic ? (
                              <img
                                src={`${IMAGE_URL}${i.profilepic}`}
                                alt="profile"
                                className="profile-img"
                              />
                            ) : (
                              <UserDefaultLogo
                                user={{
                                  name: i.imprest_name,
                                  profilepic: i.profilepic,
                                }}
                                customStyleforParent={
                                  "reqOutDuty-default-logo-dashboard"
                                }
                                customStyleforChild={"small-profile"}
                              />
                            )}
                          </CustomImageModal>
                          <p>
                            {i.empcode}-{i.imprest_name}
                          </p>
                        </td>

                        <td className="table-body">{formatDate(i.date)}</td>

                        <td
                          title="Approval Dates"
                          className="table-body width-10vw"
                        >
                          {i.rh_leave_status === "approved" ? (
                            <span
                              request-status={i.rh_leave_status}
                              className="request-status "
                            >
                              Rh ({i.rh_assigned} - {i.rh_assigned_name})
                              Approved
                              {i.rh_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {formatDateTime(i.rh_update_datetime).date}
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          {i.admin_leave_status === "approved" ? (
                            <span
                              request-status={i.admin_leave_status}
                              className="request-status "
                            >
                              Admin{" "}
                              {i.admin_update_by
                                ? `(${i.admin_update_by} - ${i.admin_update_by_name || ""})`
                                : ""}{" "}
                              Approved
                              {i.admin_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {formatDateTime(i.admin_update_datetime).date}
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          {i.account_leave_status === "approved" ? (
                            <span
                              request-status={i.account_leave_status}
                              className="request-status "
                            >
                              Accounts
                              {i.account_update_by
                                ? `(${i.account_update_by} - ${i.account_update_by_name})`
                                : ""}{" "}
                              Approved
                              {i.account_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {
                                    formatDateTime(i.account_update_datetime)
                                      .date
                                  }
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>

                        <td className="table-body">{i.project_name}</td>

                        {i.rh_leave_status === "approved" ? (
                          <td
                            className="align-leftt"
                            title={`Reason For Change : \n${i.amount_change_reason}`}
                          >
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Transportation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_transportation || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Accommodation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_accomodation || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Food
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_fooding || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <b>
                                    <td
                                      className="table-body"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Approved Others
                                    </td>
                                  </b>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td
                                    className="align-right table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>
                                      {formatCurrencyIndian(
                                        i.other_details?.reduce(
                                          (sum, other) =>
                                            sum +
                                            (parseFloat(other.approved_other) ||
                                              0),
                                          0,
                                        ),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                                {i.other_details?.length > 0 ? (
                                  <>
                                    {i.other_details.map((other, index) => (
                                      <tr key={index}>
                                        <td
                                          className="table-body word-wrap-10vw"
                                          style={{
                                            paddingLeft: "5px",
                                            paddingBottom: "5px",
                                          }}
                                        >
                                          {other.other_name
                                            ? other.other_name
                                            : `Other-${index + 1}`}
                                        </td>
                                        <td style={{ padding: "0px 4px" }}>
                                          :
                                        </td>
                                        <td
                                          className="align-right"
                                          style={{ paddingBottom: "5px" }}
                                        >
                                          {formatCurrencyIndian(
                                            other.approved_other || 0,
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ) : (
                                  <tr>
                                    <td
                                      style={{
                                        paddingBottom: "5px",
                                        paddingLeft: "5px",
                                      }}
                                      colSpan={3}
                                    >
                                      No Other Amount
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td>
                                    <b>Total</b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(i.approved_transportation) +
                                        Number(i.approved_accomodation) +
                                        Number(i.approved_fooding) +
                                        (i.other_details?.length > 0
                                          ? i.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(
                                                other.approved_other || 0,
                                              ),
                                            0,
                                          )
                                          : 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        ) : (
                          <td className="table-body">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Transportation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.transportation)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Accommodation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.accomodation)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Food
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.fooding)}
                                  </td>
                                </tr>
                                <tr>
                                  <b>
                                    <td
                                      className="table-body"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Others
                                    </td>
                                  </b>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {i.other_details
                                        ?.reduce(
                                          (sum, other) =>
                                            sum +
                                            (parseFloat(other.amount) || 0),
                                          0,
                                        )
                                        .toLocaleString()}
                                    </b>
                                  </td>
                                </tr>
                                {i.other_details?.length > 0 ? (
                                  <>
                                    {i.other_details.map((other, index) => (
                                      <>
                                        <tr>
                                          <td
                                            style={{
                                              paddingLeft: "5px",
                                              paddingBottom: "5px",
                                            }}
                                            className="table-body word-wrap-10vw"
                                          >
                                            {other.other_name
                                              ? other.other_name
                                              : `Other-${index + 1}`}
                                          </td>
                                          <td style={{ padding: "0px 4px" }}>
                                            :
                                          </td>

                                          <td className="align-right">
                                            {formatCurrencyIndian(
                                              other.amount || 0,
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ))}
                                  </>
                                ) : (
                                  <td
                                    style={{
                                      paddingBottom: "5px",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    No Other Amount
                                  </td>
                                )}
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>Total </b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(i.transportation) +
                                        Number(i.accomodation) +
                                        Number(i.fooding) +
                                        (i.other_details?.length > 0
                                          ? i.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(other.amount || 0),
                                            0,
                                          )
                                          : 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        )}
                        <td className="table-body">
                          For <b>{i.no_of_days}</b> Days with <br />{" "}
                          <b>{i.person}</b>{" "}
                          {i.person > 1 ? "people." : "person."}
                        </td>
                        <td className="table-body">
                          <ul style={{ paddingLeft: "20px" }}>
                            {i.multiple_person_details?.map((items) => {
                              return (
                                <li>
                                  {items.emp_code} - {items.name}
                                  <br />
                                </li>
                              );
                            })}
                          </ul>
                        </td>
                        <td className="table-body">{i.remarks}</td>
                        <td className="table-body">
                          <span
                            request-status={i.rh_leave_status}
                            className="request-status"
                            title={`${i.rh_leave_status === "rejected" ? `TL Reason For Rejection : \n${i.rejection_reason}` : ""}`}
                          >
                            {i.rh_leave_status === "pending" ? (
                              "Pending For Rh Approval ⌛"
                            ) : i.rh_leave_status === "rejected" ? (
                              <>
                                Rh ✖,
                                <br />
                                Rh Reject Reason:
                                <br />"{i.rejection_reason}"
                              </>
                            ) : (
                              "Approved By Rh ✔,"
                            )}
                          </span>
                          <br />
                          <span
                            request-status={i.admin_leave_status}
                            className="request-status"
                            title={`${i.admin_leave_status === "rejected" ? `Admin Reason: ${i.admin_rejection_reason}` : ""}`}
                          >
                            {i.admin_leave_status === "rejected" ? (
                              <>
                                Admin ✖,
                                <br />
                                Admin Reject Reason: "{i.admin_rejection_reason}
                                "
                              </>
                            ) : i.admin_leave_status === "pending" ? (
                              "Pending For Admin Approval ⌛,"
                            ) : i.admin_leave_status === "approved" ? (
                              "Approved By Admin ✔,"
                            ) : (
                              "Admin Status: " + i.admin_leave_status
                            )}
                          </span>
                          <br />
                          <span
                            request-status={i.account_leave_status}
                            className="request-status"
                            title={`${i.account_leave_status === "rejected" ? `Account Reason: ${i.account_rejection_reason}` : ""}`}
                          >
                            {i.account_leave_status === "rejected" ? (
                              <>
                                Accounts ✖,
                                <br />
                                Accounts Reject Reason:
                                <br />"{i.account_rejection_reason}"
                              </>
                            ) : i.account_leave_status === "pending" ? (
                              "Pending For Account Approval ⌛"
                            ) : i.account_leave_status === "approved" ? (
                              "Approved By Accounts ✔,"
                            ) : (
                              "Accounts Status : " + i.account_leave_status
                            )}
                          </span>
                        </td>
                        <td className="table-body">
                          <div className="flex-row">
                            <>
                              {i.admin_leave_status === "approved" ? (
                                <></>
                              ) : (
                                <ImprestApproveAdmin
                                  i={i}
                                  getImprestname={getimprestname}
                                />
                              )}
                            </>
                            {/* <RequestOutdutyapproved i={i} getimprestname={getimprestname} /> */}
                            <>
                              {i.admin_leave_status === "rejected" ? (
                                <></>
                              ) : (
                                <ImprestRejectAdmin
                                  i={i}
                                  getImprestname={getimprestname}
                                />
                              )}
                            </>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestExpensetableHOD = () => {
  const location = useLocation();
  let filters_fromdate =
    location.state?.filter_fromdate !== null
      ? location.state?.filter_fromdate
      : "null";
  let filters_todate =
    location.state?.filter_todate !== null
      ? location.state?.filter_todate
      : "null";
  let filters_status =
    location.state?.filter_status !== null
      ? location.state?.filter_status
      : "pending";
  let filters_employee =
    location.state?.filter_employee !== null
      ? location.state?.filter_employee
      : "null";
  let filters_department =
    location.state?.filters_department !== null
      ? location.state?.filters_department
      : `null`;
  let filters_subCompany =
    location.state?.filter_subCompany !== null
      ? location.state?.filter_subCompany
      : `${sessionStorage.getItem("company_id")}`;
  let filters_empstatus =
    location.state?.filter_empstatus !== null
      ? location.state?.filter_empstatus
      : "active";

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [departmentLists, setDepartmentLists] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [fromdate, setFromDate] = useState(filters_fromdate || "null");
  const [todate, setToDate] = useState(filters_todate || "null");
  const [selectedStatus, setSelectedStatus] = useState(
    filters_status || "pending",
  );
  const [employeeGet, setEmployeeGet] = useState(filters_employee || "null");
  const [selectedDepartment, setSelectedDepartment] = useState(
    filters_department || "null",
  );
  const [selectedDivision, setDivision] = useState(
    filters_subCompany || `${sessionStorage.getItem("company_id")}`,
  );
  const [active, setActive] = useState(filters_empstatus || "active");

  const [selectedProject, setSelectedProject] = useState("");

  const [expenseDateSorting, setExpenseDateSorting] = useState("null");
  const [expenseAmountSorting, setExpenseAmountSorting] = useState("null");

  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  //! ******************************API start***************************//
  const getexpansename = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
      const res = await axios.get(
        `${BASE_URL}/wfm/expensebyhodlte7000/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${selectedDepartment}/${selectedDivision}/${active}/`,
      );
      // setOutdutyName(res.data);
      let filteredData = res.data;

      // Sorting logic for Expense
      switch (expenseDateSorting) {
        case "asc_date":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.date ? new Date(a.date) : new Date(0);
            const bDate = b.date ? new Date(b.date) : new Date(0);
            return aDate - bDate;
          });
          break;
        case "desc_date":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.date ? new Date(a.date) : new Date(0);
            const bDate = b.date ? new Date(b.date) : new Date(0);
            return bDate - aDate;
          });
          break;
        case "asc_bill":
          filteredData = filteredData.sort((a, b) => {
            const aDatesList =
              a.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const bDatesList =
              b.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
            const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
            return aFirstDate - bFirstDate;
          });
          break;
        case "desc_bill":
          filteredData = filteredData.sort((a, b) => {
            const aDatesList =
              a.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const bDatesList =
              b.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
            const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
            return bFirstDate - aFirstDate;
          });
          break;
        case "asc_settlement":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.final_update_datetime
              ? new Date(a.final_update_datetime)
              : new Date(0);
            const bDate = b.final_update_datetime
              ? new Date(b.final_update_datetime)
              : new Date(0);
            return aDate - bDate;
          });
          break;
        case "desc_settlement":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.final_update_datetime
              ? new Date(a.final_update_datetime)
              : new Date(0);
            const bDate = b.final_update_datetime
              ? new Date(b.final_update_datetime)
              : new Date(0);
            return bDate - aDate;
          });
          break;
        default:
          filteredData = filteredData;
          break;
      }
      // Sorting logic for Imprest Amount
      switch (expenseAmountSorting) {
        case "asc_amount":
          filteredData = filteredData.sort((a, b) => {
            const aAmount = a.utilized_amount ? Number(a.utilized_amount) : 0;
            const bAmount = b.utilized_amount ? Number(b.utilized_amount) : 0;
            return aAmount - bAmount;
          });
          break;
        case "desc_amount":
          filteredData = filteredData.sort((a, b) => {
            const aAmount = a.utilized_amount ? Number(a.utilized_amount) : 0;
            const bAmount = b.utilized_amount ? Number(b.utilized_amount) : 0;
            return bAmount - aAmount;
          });
          break;
        default:
          filteredData = filteredData;
          break;
      }
      setOutdutyName(filteredData);
      setFilteredData(filteredData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getexpansename();
    getSubCompany();
  }, [
    fromdate,
    todate,
    selectedStatus,
    employeeGet,
    selectedDivision,
    expenseDateSorting,
    expenseAmountSorting,
  ]);

  const getFilterData = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllemployee(sortedList);
      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedDivision || "null"}/active/`,
      );
      setDepartmentLists(dep.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getFilterData();
  }, [active, selectedDivision]);
  //! *********** Employee Details Api End ***********

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/requestExpenseSlip/`;
  const opener = "admin";
  let filter_fromdate = fromdate;
  let filter_todate = todate;
  let filter_status = selectedStatus;
  let filter_employee = employeeGet;
  let filter_subCompany = selectedDivision;
  let filter_empstatus = active;

  const openExenseSlip = (i) => {
    navigate(baseUrl + i.id + "/", {
      state: {
        i,
        opener,
        filter_fromdate,
        filter_todate,
        filter_status,
        filter_employee,
        filter_subCompany,
        filter_empstatus,
      },
    });
  };

  const options = allemployee
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: "null", label: "Select Employee Code" };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      // Set selected employee code(s)
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null); // Clear selection
    }
  };

  const handleExpenseDateSortChange = (e) =>
    setExpenseDateSorting(e.target.value);
  const handleExpenseAmountSortChange = (e) =>
    setExpenseAmountSorting(e.target.value);

  const applyFilters = () => {
    let filteredData = outdutyname;

    if (selectedProject !== "") {
      const lowercaseSelectedProject = selectedProject.toLowerCase();
      filteredData = filteredData?.filter((data) => {
        const nameMatch = data.imprest_data?.ref_project_name
          ?.toLowerCase()
          .includes(lowercaseSelectedProject);
        const codeMatch = data.imprest_data?.ref_project_code
          ?.toString()
          .includes(selectedProject);
        return nameMatch || codeMatch;
      });
    }

    if (selectedDepartment !== "null") {
      filteredData = filteredData.filter(
        (data) => data.department === selectedDepartment,
      );
    }

    setFilteredData(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [outdutyname, selectedProject, selectedDepartment]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Employee />
              <Select
                className="attendance-input-field width-15vw"
                width="200px"
                options={[nullOption, ...options]} // Include "null" option at the beginning
                placeholder="Select Employee Code"
                value={
                  options.find((option) => option.value === employeeGet) ||
                  nullOption
                } // Ensure the correct option is selected
                onChange={handleChange}
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    color: "#707070",
                    outline: "none",
                    border: "none",
                    padding: "0.6rem 0.5rem",
                    textTransform: "capitalize",
                    boxShadow: "none",
                    "&:hover": {
                      border: "none",
                    },
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: "#707070",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: "#707070",
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    filter: "invert(50%)",
                    cursor: "pointer",
                    left: "9.5rem",
                    width: "20px",
                    height: "20px",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // Ensure dropdown menu appears above other elements
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    color: state.isSelected ? "#2576bc" : "#707070",
                    backgroundColor: state.isSelected
                      ? "rgba(37,118,188,0.1)"
                      : "white",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#2576bc",
                      color: "white",
                    },
                  }),
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer ? (
                <div className="align-center form-loader">
                  <div className="bar-loader"></div>
                </div>
              ) : (
                <>
                  <CircularGrid />
                  <select
                    className="attendance-input-field width-15vw   date-field"
                    type="text"
                    value={selectedDepartment}
                    onChange={(e) => setSelectedDepartment(e.target.value)}
                  >
                    <option value="null">All Department</option>
                    {departmentLists
                      .sort((a, b) => a.title - b.title)
                      .map((i, index) => (
                        <option value={i.id}>{i.title}</option>
                      ))}
                    ;
                  </select>
                </>
              )}
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-10vw date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="null">All Sub Companies</option>
                {SubCompany.sort((a, b) => a.title - b.title).map(
                  (i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ),
                )}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              {/* <Project /> */}
              {buffer ? (
                <div className="align-center justify-center">
                  <div className=" form-loader">
                    <div className="bar-loader"></div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="field-cont-div">
                    <SearchBig />
                    <input
                      className="attendance-input-field width-15vw  "
                      placeholder="By Project Code, Name"
                      type="text"
                      value={selectedProject}
                      onChange={(e) => setSelectedProject(e.target.value)}
                    />
                  </div>
                </>
              )}
              <hr className="field-cont-hr" />
            </div>
            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={expenseDateSorting}
                onChange={handleExpenseDateSortChange}
              >
                <option value="null">No Expense Date Filter</option>
                <option value="asc_date">Asc. Expense Date</option>
                <option value="desc_date">Desc. Expense Date</option>
                {/* <option value="asc_bill">Asc. Expense Bills</option>
                <option value="desc_bill">Desc. Expense Bills</option>
                <option value="asc_settlement">Asc. Expense Settlement</option>
                <option value="desc_settlement">Desc. Expense Settlement</option> */}
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={expenseAmountSorting}
                onChange={handleExpenseAmountSortChange}
              >
                <option value="null">No Expense Amount Filter</option>
                <option value="asc_amount">Asc. Expense Amount</option>
                <option value="desc_amount">Desc. Expense Amount</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new scroll-container-table">
          {/* <div className="table-heading-flex"> */}
          {/* <div className="repo-heading font-weight500    font-size-heading">Expense</div> */}

          {/* </div> */}
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-0P">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Date</th>
                <th className="table-heading">
                  Expense <b>Against</b> Imprest
                </th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Imprest Amount
                </th>
                <th className="table-heading">Utilized Money</th>
                <th className="table-heading">Remaining Money</th>
                <th className="table-heading">Status</th>
                <th className="table-heading width-15vw">Remarks</th>
                <th className="table-heading">View/Action</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {filteredData?.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="8"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="table-body">{index + 1}</td>

                      <td className="table-body">
                        {i.imprest_data?.project_id ? (
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body">Project Code</td>
                                <td
                                  className="table-body"
                                  style={{ padding: "0px 4px" }}
                                >
                                  :
                                </td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body">Project Name</td>
                                <td
                                  className="table-body"
                                  style={{ padding: "0px 4px" }}
                                >
                                  :
                                </td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : (
                          <div className="align-center justify-center">
                            - No Project Referenced -
                          </div>
                        )}
                      </td>

                      <td
                        className="table-body"
                        style={{ textAlign: "center" }}
                      >
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{
                                name: i.emp_name,
                                profilepic: i.profilepic,
                              }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode}-{i.emp_name}
                        </p>
                      </td>
                      <td className="table-body">{formatDate(i.date)}</td>
                      <td className="table-body width-5vw">
                        <span>{i.name}</span>
                        <br />
                        <b> Against </b>
                        <br />
                        <span className="word-wrap-10vw">{i.project_name}</span>
                      </td>
                      <td className="table-body">
                        <table
                          style={{ borderCollapse: "collapse", width: "100%" }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Transportation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_transportation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Accommodation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_accomodation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Food
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(i.approved_fooding || 0)}
                              </td>
                            </tr>
                            <tr>
                              <b>
                                <td
                                  className="table-body"
                                  style={{ paddingBottom: "5px" }}
                                >
                                  Others
                                </td>
                              </b>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    i.other_details?.reduce(
                                      (sum, other) =>
                                        sum + Number(other.approved_other || 0),
                                      0,
                                    ),
                                  )}
                                </b>
                              </td>
                            </tr>
                            {i.other_details?.length > 0 ? (
                              <>
                                {i.other_details.map((other, index) => (
                                  <tr key={index}>
                                    <td
                                      className="table-body word-wrap-10vw"
                                      style={{
                                        paddingLeft: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {other.other_name
                                        ? other.other_name
                                        : `Other-${index + 1}`}
                                    </td>
                                    <td style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right">
                                      {formatCurrencyIndian(
                                        other.approved_other || 0,
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  style={{
                                    padding: "0px 4px",
                                    paddingBottom: "5px",
                                  }}
                                  colSpan={3}
                                >
                                  No Other Expense
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                <b>Total</b>
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    Number(i.approved_transportation) +
                                    Number(i.approved_accomodation) +
                                    Number(i.approved_fooding) +
                                    (i.other_details?.length > 0
                                      ? i.other_details.reduce(
                                        (total, other) =>
                                          total +
                                          Number(other.approved_other || 0),
                                        0,
                                      )
                                      : 0),
                                  )}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="table-body align-center">
                        {i.utilized_amount
                          ? formatRoundoff2D(i.utilized_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body align-center">
                        {i.remaining_amount
                          ? formatRoundoff2D(i.remaining_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body">
                        <span
                          request-status={i.rh_status}
                          className="request-status align-center"
                          title={
                            i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_status === "rejected"
                              ? "Rh ✖, "
                              : "Rh ✔, "}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status align-center"
                          title={
                            i.account_status_a === "rejected"
                              ? `Account Reject Reason : ${i.account1_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_a === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_a === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_a === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_a === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 1: " + i.account_status_a}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status align-center"
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected"
                            ? "Admin ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "pending"
                              ? "Pending For Admin Approval ⌛,"
                              : i.rh_status === "approved" &&
                                i.admin_status === "rejected"
                                ? "Admin ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved"
                                  ? "Admin ✔, "
                                  : "Admin Status: " + i.admin_status}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status align-center"
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_b === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_b === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_b === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 2: " + i.account_status_b}
                        </span>
                      </td>
                      <td
                        title="Remarks and Approval Dates"
                        className="table-body"
                      >
                        <span
                          request-status={i.rh_status}
                          className="request-status "
                        >
                          {i.rh_status === "pending"
                            ? "-"
                            : i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : `Rh${i.rh_assigned ? `(${i.rh_assigned}-${i.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${i.rh_update_datetime ? `At: ${formatDateTime(i.rh_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status "
                        >
                          {i.account_status_a === "pending"
                            ? "-"
                            : i.account_status_a === "rejected"
                              ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                              : `Accounts${i.account_update_by ? `(${i.account_update_by}-${i.account_update_by_name || ""}) ` : ""}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status "
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.admin_status === "pending"
                            ? "-"
                            : i.admin_status === "rejected"
                              ? `Admin Rejection Reason : ${i.admin_rejection_reason}`
                              : `Admin${i.admin_update_by ? `(${i.admin_update_by}-${i.admin_update_by_name || ""}) ` : ""}: Approved After Final Verification  ${i.admin_update_datetime ? `At: ${formatDateTime(i.admin_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status"
                        >
                          {i.account_status_b === "pending"
                            ? "-"
                            : i.account_status_b === "rejected"
                              ? `Final Rejection Reason : ${i.account2_rejection_reason}`
                              : `Final${i.final_update_by ? `(${i.final_update_by}-${i.final_update_by || ""}) ` : ""}: Approved And Settled ${i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date}` : ""}`}
                        </span>
                      </td>
                      <td className="table-body align-center">
                        <button
                          className="allproject-dashboard"
                          title="View using Navigate"
                          onClick={(e) => openExenseSlip(i)}
                        >
                          <Eye />
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestImpresttableAdmin = () => {
  const { PERMISSION_ASSIGNED_ADMIN, PERMISSION_AUTHORITY } = usePermission();
  // *********** Employee Details Api Start ***********

  const [buffer, setBuffering] = useState(true); //buffering logic

  const [allemployee, setAllemployee] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("pending");

  const [employeeGet, setEmployeeGet] = useState("null");
  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");

  const [selectedDivision, setDivision] = useState(
    `${sessionStorage.getItem("company_id")}`,
  );

  const [active, setActive] = useState("active");

  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  //! ******************************API start***************************//
  const getimprestname = async () => {
    try {
      setBuffering(true); //buffering logic // Start Buffering
      const res = await axios.get(
        `${BASE_URL}/wfm/imprestbyadmin/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${selectedDivision}/${active}/`,
      );
      setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getSubCompany();
    getimprestname();
  }, [fromdate, todate, selectedStatus, employeeGet, selectedDivision]);

  const getEmpcode = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllemployee(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getEmpcode();
  }, [active, selectedDivision]);
  //! *********** Employee Details Api End ***********

  const options = allemployee
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: "null", label: "Select Employee Code" };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      // Set selected employee code(s)
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null); // Clear selection
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Employee />
              <Select
                className="attendance-input-field width-15vw"
                width="200px"
                options={[nullOption, ...options]} // Include "null" option at the beginning
                placeholder="Select Employee Code"
                value={
                  options.find((option) => option.value === employeeGet) ||
                  nullOption
                } 
                 isClearable
                onChange={handleChange}
                styles={CSSForFilterDropdown}
              />
              {/* <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="null">Select Employee Code </option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select> */}
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="null"> All Sub Companies</option>
                {SubCompany.sort((a, b) => a.title - b.title).map(
                  (i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ),
                )}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new scroll-container-table">
          <div className="table-heading-flex">
            {/* <div className="repo-heading font-weight500    font-size-heading">Imprest </div> */}
          </div>
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-new">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Imprest Date</th>
                <th className="table-heading">Dates</th>
                <th className="table-heading width-5vw">Imprest Name</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Total Amount
                </th>
                <th className="table-heading">Days And Employee Count</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Person Name
                </th>
                <th className="table-heading">Remarks</th>
                <th className="table-heading">Status</th>
                <th
                  className="table-heading width-5vw"
                  style={{ textAlign: "center" }}
                >
                  Action
                </th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {outdutyname
                  .sort((a, b) => {
                    const dateA = a.admin_update_datetime
                      ? new Date(a.admin_update_datetime)
                      : null;
                    const dateB = b.admin_update_datetime
                      ? new Date(b.admin_update_datetime)
                      : null;
                    if (dateA && dateB) {
                      return dateB - dateA;
                    }
                    if (dateA) return -1;
                    if (dateB) return 1;
                    return 0;
                  })
                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr
                        className="custom-table-head-td"
                        title={`Admin Status : ${i.admin_leave_status}`}
                      >
                        <td className="table-body">{index + 1}</td>
                        {/* <td className="table-body">
                          {i.project_id ?
                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td className="table-body" >Project Code</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right word-wrap-20vw">
                                    {i.ref_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body text-left" >Project Name</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right word-wrap-20vw">
                                    {i.ref_project_name}
                                  </td>
                                </tr>

                              </tbody>
                            </table> :
                            <div className="align-center justify-center">
                              - No Project Referenced -
                            </div>
                          }
                        </td> */}
                        <td className="table-body">
                          {i?.mantra_project_details?.mantra_project_id ? (
                            // Priority 1: Mantra project exists
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right  word-wrap-10vw">
                                    {i?.mantra_project_details?.mantra_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right  word-wrap-15vw">
                                    {i?.mantra_project_details?.mantra_project_name}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : i?.project_id ? (
                            // Priority 2: Fallback to ref project
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right word-wrap-10vw">
                                    {i?.ref_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right word-wrap-15vw">
                                    {i?.ref_project_name}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            // Priority 3: No project at all
                            <div className="justify-center">
                              - No Project Referenced -
                            </div>
                          )}
                        </td>
                        <td
                          className="table-body"
                          style={{ textAlign: "center" }}
                        >
                          <CustomImageModal customStyle>
                            {i.profilepic ? (
                              <img
                                src={`${IMAGE_URL}${i.profilepic}`}
                                alt="profile"
                                className="profile-img"
                              />
                            ) : (
                              <UserDefaultLogo
                                user={{
                                  name: i.imprest_name,
                                  profilepic: i.profilepic,
                                }}
                                customStyleforParent={
                                  "reqOutDuty-default-logo-dashboard"
                                }
                                customStyleforChild={"small-profile"}
                              />
                            )}
                          </CustomImageModal>
                          <p>
                            {i.empcode}-{i.imprest_name}
                          </p>
                        </td>

                        <td className="table-body">{formatDate(i.date)}</td>

                        <td
                          title="Approval Dates"
                          className="table-body width-10vw"
                        >
                          {i.rh_leave_status === "approved" ? (
                            <span
                              request-status={i.rh_leave_status}
                              className="request-status "
                            >
                              Rh ({i.rh_assigned} - {i.rh_assigned_name})
                              Approved
                              {i.rh_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {formatDateTime(i.rh_update_datetime).date}
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          {i.admin_leave_status === "approved" ? (
                            <span
                              request-status={i.admin_leave_status}
                              className="request-status "
                            >
                              Admin{" "}
                              {i.admin_update_by
                                ? `(${i.admin_update_by} - ${i.admin_update_by_name || ""})`
                                : ""}{" "}
                              Approved
                              {i.admin_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {formatDateTime(i.admin_update_datetime).date}
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          {i.account_leave_status === "approved" ? (
                            <span
                              request-status={i.account_leave_status}
                              className="request-status "
                            >
                              Accounts
                              {i.account_update_by
                                ? `(${i.account_update_by} - ${i.account_update_by_name})`
                                : ""}{" "}
                              Approved
                              {i.account_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {
                                    formatDateTime(i.account_update_datetime)
                                      .date
                                  }
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>

                        <td className="table-body word-wrap-15vw">
                          {i?.mantra_project_details?.mantra_project_id
                            ? `${i?.mantra_project_details?.mantra_project_code}-${i?.mantra_project_details?.mantra_project_name}`
                            : `${i?.project_name}`}
                          {/* {i.project_name} */}
                        </td>

                        {i.rh_leave_status === "approved" ? (
                          <td
                            className="table-body"
                            title={`Reason For Change : \n${i.amount_change_reason}`}
                          >
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Transportation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_transportation || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Accommodation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_accomodation || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Food
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_fooding || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <b>
                                    <td
                                      className="table-body"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Approved Others
                                    </td>
                                  </b>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td
                                    className="align-right table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>
                                      {formatCurrencyIndian(
                                        i.other_details?.reduce(
                                          (sum, other) =>
                                            sum +
                                            (parseFloat(other.approved_other) ||
                                              0),
                                          0,
                                        ),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                                {i.other_details?.length > 0 ? (
                                  <>
                                    {i.other_details.map((other, index) => (
                                      <tr key={index}>
                                        <td
                                          className="table-body word-wrap-10vw"
                                          style={{
                                            paddingLeft: "5px",
                                            paddingBottom: "5px",
                                          }}
                                        >
                                          {other.other_name
                                            ? other.other_name
                                            : `Other-${index + 1}`}
                                        </td>
                                        <td style={{ padding: "0px 4px" }}>
                                          :
                                        </td>
                                        <td
                                          className="align-right"
                                          style={{ paddingBottom: "5px" }}
                                        >
                                          {formatCurrencyIndian(
                                            other.approved_other || 0,
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ) : (
                                  <tr>
                                    <td
                                      style={{
                                        paddingBottom: "5px",
                                        paddingLeft: "5px",
                                      }}
                                      colSpan={3}
                                    >
                                      No Other Amount
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td>
                                    <b>Total</b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(i.approved_transportation) +
                                        Number(i.approved_accomodation) +
                                        Number(i.approved_fooding) +
                                        (i.other_details?.length > 0
                                          ? i.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(
                                                other.approved_other || 0,
                                              ),
                                            0,
                                          )
                                          : 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        ) : (
                          <td className="table-body">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Transportation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.transportation)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Accommodation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.accomodation)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Food
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.fooding)}
                                  </td>
                                </tr>
                                <tr>
                                  <b>
                                    <td
                                      className="table-body"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Others
                                    </td>
                                  </b>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {i.other_details
                                        ?.reduce(
                                          (sum, other) =>
                                            sum +
                                            (parseFloat(other.amount) || 0),
                                          0,
                                        )
                                        .toLocaleString()}
                                    </b>
                                  </td>
                                </tr>
                                {i.other_details?.length > 0 ? (
                                  <>
                                    {i.other_details.map((other, index) => (
                                      <>
                                        <tr>
                                          <td
                                            style={{
                                              paddingLeft: "5px",
                                              paddingBottom: "5px",
                                            }}
                                            className="table-body word-wrap-10vw"
                                          >
                                            {other.other_name
                                              ? other.other_name
                                              : `Other-${index + 1}`}
                                          </td>
                                          <td style={{ padding: "0px 4px" }}>
                                            :
                                          </td>

                                          <td className="align-right">
                                            {formatCurrencyIndian(
                                              other.amount || 0,
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ))}
                                  </>
                                ) : (
                                  <td
                                    style={{
                                      paddingBottom: "5px",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    No Other Amount
                                  </td>
                                )}
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>Total </b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(i.transportation) +
                                        Number(i.accomodation) +
                                        Number(i.fooding) +
                                        (i.other_details?.length > 0
                                          ? i.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(other.amount || 0),
                                            0,
                                          )
                                          : 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        )}
                        <td className="table-body">
                          For <b>{i.no_of_days}</b> Days with <br />{" "}
                          <b>{i.person}</b>{" "}
                          {i.person > 1 ? "people." : "person."}
                        </td>
                        <td className="table-body">
                          <ul style={{ paddingLeft: "20px" }}>
                            {i.multiple_person_details?.map((items) => {
                              return (
                                <li>
                                  {items.emp_code} - {items.name}
                                  <br />
                                </li>
                              );
                            })}
                          </ul>
                        </td>
                        <td className="table-body">{i.remarks}</td>
                        <td className="table-body">
                          <span
                            request-status={i.rh_leave_status}
                            className="request-status"
                            title={`${i.rh_leave_status === "rejected" ? `TL Reason For Rejection : \n${i.rejection_reason}` : ""}`}
                          >
                            {i.rh_leave_status === "pending" ? (
                              "Pending For Rh Approval ⌛"
                            ) : i.rh_leave_status === "rejected" ? (
                              <>
                                Rh ✖,
                                <br />
                                Rh Reject Reason:
                                <br />"{i.rejection_reason}"
                              </>
                            ) : (
                              "Approved By Rh ✔,"
                            )}
                          </span>
                          <br />
                          <span
                            request-status={i.admin_leave_status}
                            className="request-status"
                            title={`${i.admin_leave_status === "rejected" ? `Admin Reason: ${i.admin_rejection_reason}` : ""}`}
                          >
                            {i.admin_leave_status === "rejected" ? (
                              <>
                                Admin ✖,
                                <br />
                                Admin Reject Reason: "{i.admin_rejection_reason}
                                "
                              </>
                            ) : i.admin_leave_status === "pending" ? (
                              "Pending For Admin Approval ⌛,"
                            ) : i.admin_leave_status === "approved" ? (
                              "Approved By Admin ✔,"
                            ) : (
                              "Admin Status: " + i.admin_leave_status
                            )}
                          </span>
                          <br />
                          <span
                            request-status={i.account_leave_status}
                            className="request-status"
                            title={`${i.account_leave_status === "rejected" ? `Account Reason: ${i.account_rejection_reason}` : ""}`}
                          >
                            {i.account_leave_status === "rejected" ? (
                              <>
                                Accounts ✖,
                                <br />
                                Accounts Reject Reason:
                                <br />"{i.account_rejection_reason}"
                              </>
                            ) : i.account_leave_status === "pending" ? (
                              "Pending For Account Approval ⌛"
                            ) : i.account_leave_status === "approved" ? (
                              "Approved By Accounts ✔,"
                            ) : (
                              "Accounts Status : " + i.account_leave_status
                            )}
                          </span>
                        </td>
                        <td className="table-body">
                          <div className="flex-row">
                            <>
                              {PERMISSION_AUTHORITY ||
                                PERMISSION_ASSIGNED_ADMIN ? (
                                i.admin_leave_status === "approved" ? (
                                  <></>
                                ) : (
                                  <AdminapprovedHR
                                    i={i}
                                    getImprestname={getimprestname}
                                  />
                                )
                              ) : (
                                <></>
                              )}
                            </>
                            {/* <RequestOutdutyapproved i={i} getimprestname={getimprestname} /> */}
                            <>
                              {PERMISSION_AUTHORITY ||
                                PERMISSION_ASSIGNED_ADMIN ? (
                                i.admin_leave_status === "rejected" ? (
                                  <></>
                                ) : (
                                  <AdminDeleteHR
                                    i={i}
                                    getImprestname={getimprestname}
                                  />
                                )
                              ) : (
                                <></>
                              )}
                            </>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestExpensetableAdmin = () => {
  const location = useLocation();
  let filters_fromdate =
    location.state?.filter_fromdate !== null
      ? location.state?.filter_fromdate
      : "null";
  let filters_todate =
    location.state?.filter_todate !== null
      ? location.state?.filter_todate
      : "null";
  let filters_status =
    location.state?.filter_status !== null
      ? location.state?.filter_status
      : "pending";
  let filters_employee =
    location.state?.filter_employee !== null
      ? location.state?.filter_employee
      : "null";
  let filters_department =
    location.state?.filters_department !== null
      ? location.state?.filters_department
      : `null`;
  let filters_subCompany =
    location.state?.filter_subCompany !== null
      ? location.state?.filter_subCompany
      : `${sessionStorage.getItem("company_id")}`;
  let filters_empstatus =
    location.state?.filter_empstatus !== null
      ? location.state?.filter_empstatus
      : "active";
  let filters_selectedProject =
    location.state?.filter_selectedProject !== null
      ? location.state?.filter_selectedProject
      : "";
  let filters_expenseDateSorting =
    location.state?.filter_expenseDateSorting !== null
      ? location.state?.filter_expenseDateSorting
      : "null";
  let filters_expenseAmountSorting =
    location.state?.filter_expenseAmountSorting !== null
      ? location.state?.filter_expenseAmountSorting
      : "null";

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [departmentLists, setDepartmentLists] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true);
  const [fromdate, setFromDate] = useState(filters_fromdate || "null");
  const [todate, setToDate] = useState(filters_todate || "null");
  const [selectedStatus, setSelectedStatus] = useState(
    filters_status || "pending",
  );
  const [employeeGet, setEmployeeGet] = useState(filters_employee || "null");
  const [selectedDepartment, setSelectedDepartment] = useState(
    filters_department || "",
  );
  const [selectedDivision, setDivision] = useState(
    filters_subCompany || `${sessionStorage.getItem("company_id")}`,
  );
  const [active, setActive] = useState(filters_empstatus || "active");

  const [selectedProject, setSelectedProject] = useState(
    filters_selectedProject || "",
  );
  const [expenseDateSorting, setExpenseDateSorting] = useState(
    filters_expenseDateSorting || "null",
  );
  const [expenseAmountSorting, setExpenseAmountSorting] = useState(
    filters_expenseAmountSorting || "null",
  );

  const [SubCompany, setSubCompany] = useState([]);

  const getSubCompany = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
      setSubCompany(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  //! ******************************API start***************************//
  const getexpansename = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
      const res = await axios.get(
        `${BASE_URL}/wfm/expensebyadmin/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${selectedDivision}/${active}/`,
      );
      // setOutdutyName(res.data);
      let filteredData = res.data;

      // Sorting logic for Expense
      switch (expenseDateSorting) {
        case "asc_date":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.date ? new Date(a.date) : new Date(0);
            const bDate = b.date ? new Date(b.date) : new Date(0);
            return aDate - bDate;
          });
          break;
        case "desc_date":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.date ? new Date(a.date) : new Date(0);
            const bDate = b.date ? new Date(b.date) : new Date(0);
            return bDate - aDate;
          });
          break;
        case "asc_bill":
          filteredData = filteredData.sort((a, b) => {
            const aDatesList =
              a.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const bDatesList =
              b.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
            const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
            return aFirstDate - bFirstDate;
          });
          break;
        case "desc_bill":
          filteredData = filteredData.sort((a, b) => {
            const aDatesList =
              a.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const bDatesList =
              b.expense_details
                ?.map((exp) => new Date(exp.date))
                .sort((x, y) => x - y) || [];
            const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
            const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
            return bFirstDate - aFirstDate;
          });
          break;
        case "asc_settlement":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.final_update_datetime
              ? new Date(a.final_update_datetime)
              : new Date(0);
            const bDate = b.final_update_datetime
              ? new Date(b.final_update_datetime)
              : new Date(0);
            return aDate - bDate;
          });
          break;
        case "desc_settlement":
          filteredData = filteredData.sort((a, b) => {
            const aDate = a.final_update_datetime
              ? new Date(a.final_update_datetime)
              : new Date(0);
            const bDate = b.final_update_datetime
              ? new Date(b.final_update_datetime)
              : new Date(0);
            return bDate - aDate;
          });
          break;
        default:
          filteredData = filteredData;
          break;
      }
      // Sorting logic for Imprest Amount
      switch (expenseAmountSorting) {
        case "asc_amount":
          filteredData = filteredData.sort((a, b) => {
            const aAmount = a.utilized_amount ? Number(a.utilized_amount) : 0;
            const bAmount = b.utilized_amount ? Number(b.utilized_amount) : 0;
            return aAmount - bAmount;
          });
          break;
        case "desc_amount":
          filteredData = filteredData.sort((a, b) => {
            const aAmount = a.utilized_amount ? Number(a.utilized_amount) : 0;
            const bAmount = b.utilized_amount ? Number(b.utilized_amount) : 0;
            return bAmount - aAmount;
          });
          break;
        default:
          filteredData = filteredData;
          break;
      }
      setOutdutyName(filteredData);
      setFilteredData(filteredData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false); // End Buffering
    }
  };

  useEffect(() => {
    getexpansename();
    getSubCompany();
  }, [
    fromdate,
    todate,
    selectedStatus,
    active,
    employeeGet,
    selectedDivision,
    expenseDateSorting,
    expenseAmountSorting,
  ]);

  const getFilterData = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedDivision}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllemployee(sortedList);
      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedDivision || "null"}/${active}/`,
      );
      setDepartmentLists(dep.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getFilterData();
  }, [active, selectedDivision]);
  //! *********** Employee Details Api End ***********

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/requestExpenseSlip/`;
  const opener = "admin";
  let filter_fromdate = fromdate;
  let filter_todate = todate;
  let filter_status = selectedStatus;
  let filter_employee = employeeGet;
  let filter_subCompany = selectedDivision;
  let filter_department = selectedDepartment;
  let filter_empstatus = active;
  let filter_selectedProject = selectedProject;
  let filter_expenseDateSorting = expenseDateSorting;
  let filter_expenseAmountSorting = expenseAmountSorting;

  const openExenseSlip = (i) => {
    navigate(baseUrl + i.id + "/", {
      state: {
        i,
        opener,
        filter_fromdate,
        filter_todate,
        filter_status,
        filter_employee,
        filter_subCompany,
        filter_department,
        filter_empstatus,
        filter_selectedProject,
        filter_expenseDateSorting,
        filter_expenseAmountSorting,
      },
    });
  };

  const options = allemployee
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: "null", label: "Select Employee Code" };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      // Set selected employee code(s)
      setEmployeeGet(selectedOption.value);
    } else {
      setEmployeeGet(null); // Clear selection
    }
  };

  const handleExpenseDateSortChange = (e) =>
    setExpenseDateSorting(e.target.value);
  const handleExpenseAmountSortChange = (e) =>
    setExpenseAmountSorting(e.target.value);

  const applyFilters = () => {
    let filteredData = outdutyname;

    if (selectedProject !== "") {
      const lowercaseSelectedProject = selectedProject.toLowerCase();
      filteredData = filteredData?.filter((data) => {
        const nameMatch = data.imprest_data?.ref_project_name
          ?.toLowerCase()
          .includes(lowercaseSelectedProject);
        const codeMatch = data.imprest_data?.ref_project_code
          ?.toString()
          .includes(selectedProject);
        return nameMatch || codeMatch;
      });
    }

    if (selectedDepartment !== "") {
      filteredData = filteredData.filter(
        (data) => data.department === selectedDepartment,
      );
    }

    setFilteredData(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [outdutyname, selectedProject, selectedDepartment]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />

              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Employee />
              <Select
                className="attendance-input-field width-15vw"
                width="200px"
                options={[nullOption, ...options]} // Include "null" option at the beginning
                placeholder="Select Employee Code"
                value={
                  options.find((option) => option.value === employeeGet) ||
                  nullOption
                } // Ensure the correct option is selected
                onChange={handleChange}
                isClearable
                styles={CSSForFilterDropdown}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer ? (
                <div className="align-center form-loader">
                  <div className="bar-loader"></div>
                </div>
              ) : (
                <>
                  <CircularGrid />
                  <select
                    className="attendance-input-field width-15vw   date-field"
                    type="text"
                    value={selectedDepartment}
                    onChange={(e) => setSelectedDepartment(e.target.value)}
                  >
                    <option value="">All Department</option>
                    {departmentLists
                      .sort((a, b) => a.title - b.title)
                      .map((i, index) => (
                        <option value={i.id}>{i.title}</option>
                      ))}
                    ;
                  </select>
                </>
              )}
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Office />
              <select
                className="attendance-input-field width-10vw date-field"
                type="text"
                value={selectedDivision}
                onChange={(e) => setDivision(e.target.value)}
              >
                <option value="null">All Sub Companies</option>
                {SubCompany.sort((a, b) => a.title - b.title).map(
                  (i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ),
                )}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              {/* <Project /> */}
              {buffer ? (
                <div className="align-center justify-center">
                  <div className=" form-loader">
                    <div className="bar-loader"></div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="field-cont-div">
                    <SearchBig />
                    <input
                      className="attendance-input-field width-15vw  "
                      placeholder="By Project Code, Name"
                      type="text"
                      value={selectedProject}
                      onChange={(e) => setSelectedProject(e.target.value)}
                    />
                  </div>
                </>
              )}
              <hr className="field-cont-hr" />
            </div>
            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={expenseDateSorting}
                onChange={handleExpenseDateSortChange}
              >
                <option value="null">No Expense Date Filter</option>
                <option value="asc_date">Asc. Expense Date</option>
                <option value="desc_date">Desc. Expense Date</option>
                {/* <option value="asc_bill">Asc. Expense Bills</option>
                <option value="desc_bill">Desc. Expense Bills</option>
                <option value="asc_settlement">Asc. Expense Settlement</option>
                <option value="desc_settlement">Desc. Expense Settlement</option> */}
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={expenseAmountSorting}
                onChange={handleExpenseAmountSortChange}
              >
                <option value="null">No Expense Amount Filter</option>
                <option value="asc_amount">Asc. Expense Amount</option>
                <option value="desc_amount">Desc. Expense Amount</option>
              </select>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new scroll-container-table">
          {/* <div className="table-heading-flex"> */}
          {/* <div className="repo-heading font-weight500    font-size-heading">Expense</div> */}

          {/* </div> */}
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-0P">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Date</th>
                <th className="table-heading">
                  Expense <b>Against</b> Imprest
                </th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Imprest Amount
                </th>
                <th className="table-heading">Utilized Money</th>
                <th className="table-heading">Remaining Money</th>
                <th className="table-heading">Status</th>
                <th className="table-heading width-15vw">Remarks</th>
                <th className="table-heading">View/Action</th>
              </tr>
            </thead>
            {!buffer1 && (
              <tbody>
                {filteredData?.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="8"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="table-body">{index + 1}</td>

                      {/* <td className="table-body">
                        {i.imprest_data?.project_id ?
                          <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <tbody>
                              <tr>
                                <td className="table-body" >Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" >Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_name}
                                </td>
                              </tr>

                            </tbody>
                          </table> :
                          <div className="align-center justify-center">
                            - No Project Referenced -
                          </div>
                        }
                      </td> */}

                      <td className="table-body">
                        {i?.imprest_data?.mantra_project_details
                          ?.mantra_project_id ? (
                          // Priority 1: Mantra project exists
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-10vw">
                                  {i?.imprest_data?.mantra_project_details?.mantra_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-15vw">
                                  {i?.imprest_data?.mantra_project_details?.mantra_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : i?.imprest_data?.project_id ? (
                          // Priority 2: Fallback to ref project
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-10vw">
                                  {i?.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-15vw">
                                  {i?.imprest_data?.ref_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : (
                          // Priority 3: No project at all
                          <div className="justify-center">
                            - No Project Referenced -
                          </div>
                        )}
                      </td>

                      <td
                        className="table-body"
                        style={{ textAlign: "center" }}
                      >
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{
                                name: i.emp_name,
                                profilepic: i.profilepic,
                              }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode}-{i.emp_name}
                        </p>
                      </td>
                      <td className="table-body">{formatDate(i.date)}</td>
                      <td className="table-body width-5vw">
                        <span>{i.name}</span>
                        <br />
                        <b> Against </b>
                        <br />
                        <span className="word-wrap-10vw">
                          {/* {i.project_name} */}
                          {i?.imprest_data?.mantra_project_details
                            ?.mantra_project_id
                            ? `${i?.imprest_data?.mantra_project_details?.mantra_project_code}-${i?.imprest_data?.mantra_project_details?.mantra_project_name}`
                            : `${i?.project_name}`}
                        </span>
                      </td>
                      <td className="table-body">
                        <table
                          style={{ borderCollapse: "collapse", width: "100%" }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Transportation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_transportation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Accommodation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_accomodation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Food
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(i.approved_fooding || 0)}
                              </td>
                            </tr>
                            <tr>
                              <b>
                                <td
                                  className="table-body"
                                  style={{ paddingBottom: "5px" }}
                                >
                                  Others
                                </td>
                              </b>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    i.other_details?.reduce(
                                      (sum, other) =>
                                        sum + Number(other.approved_other || 0),
                                      0,
                                    ),
                                  )}
                                </b>
                              </td>
                            </tr>
                            {i.other_details?.length > 0 ? (
                              <>
                                {i.other_details.map((other, index) => (
                                  <tr key={index}>
                                    <td
                                      className="table-body word-wrap-10vw"
                                      style={{
                                        paddingLeft: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {other.other_name
                                        ? other.other_name
                                        : `Other-${index + 1}`}
                                    </td>
                                    <td style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right">
                                      {formatCurrencyIndian(
                                        other.approved_other || 0,
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  style={{
                                    padding: "0px 4px",
                                    paddingBottom: "5px",
                                  }}
                                  colSpan={3}
                                >
                                  No Other Expense
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                <b>Total</b>
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    Number(i.approved_transportation) +
                                    Number(i.approved_accomodation) +
                                    Number(i.approved_fooding) +
                                    (i.other_details?.length > 0
                                      ? i.other_details.reduce(
                                        (total, other) =>
                                          total +
                                          Number(other.approved_other || 0),
                                        0,
                                      )
                                      : 0),
                                  )}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="table-body align-center">
                        {i.utilized_amount
                          ? formatRoundoff2D(i.utilized_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body align-center">
                        {i.remaining_amount
                          ? formatRoundoff2D(i.remaining_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body">
                        <span
                          request-status={i.rh_status}
                          className="request-status align-center"
                          title={
                            i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_status === "rejected"
                              ? "Rh ✖, "
                              : "Rh ✔, "}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status align-center"
                          title={
                            i.account_status_a === "rejected"
                              ? `Account Reject Reason : ${i.account1_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_a === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_a === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_a === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_a === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 1: " + i.account_status_a}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status align-center"
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected"
                            ? "Admin ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "pending"
                              ? "Pending For Admin Approval ⌛,"
                              : i.rh_status === "approved" &&
                                i.admin_status === "rejected"
                                ? "Admin ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved"
                                  ? "Admin ✔, "
                                  : "Admin Status: " + i.admin_status}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status align-center"
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_b === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_b === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_b === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 2: " + i.account_status_b}
                        </span>
                      </td>
                      <td
                        title="Remarks and Approval Dates"
                        className="table-body"
                      >
                        <span
                          request-status={i.rh_status}
                          className="request-status "
                        >
                          {i.rh_status === "pending"
                            ? "-"
                            : i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : `Rh${i.rh_assigned ? `(${i.rh_assigned}-${i.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${i.rh_update_datetime ? `At: ${formatDateTime(i.rh_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status "
                        >
                          {i.account_status_a === "pending"
                            ? "-"
                            : i.account_status_a === "rejected"
                              ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                              : `Accounts${i.account_update_by ? `(${i.account_update_by}-${i.account_update_by_name || ""}) ` : ""}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status "
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.admin_status === "pending"
                            ? "-"
                            : i.admin_status === "rejected"
                              ? `Admin Rejection Reason : ${i.admin_rejection_reason}`
                              : `Admin${i.admin_update_by ? `(${i.admin_update_by}-${i.admin_update_by_name || ""}) ` : ""}: Approved After Final Verification  ${i.admin_update_datetime ? `At: ${formatDateTime(i.admin_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status"
                        >
                          {i.account_status_b === "pending"
                            ? "-"
                            : i.account_status_b === "rejected"
                              ? `Final Rejection Reason : ${i.account2_rejection_reason}`
                              : `Final${i.final_update_by ? `(${i.final_update_by}-${i.final_update_by || ""}) ` : ""}: Approved And Settled ${i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date}` : ""}`}
                        </span>
                      </td>
                      <td className="table-body align-center">
                        <button
                          className="allproject-dashboard"
                          title="View using Navigate"
                          onClick={(e) => openExenseSlip(i)}
                        >
                          <Eye />
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
          {buffer1 && <Loader container={true} />}
        </div>
      </div>
    </>
  );
};

const RequestImpresttableAcc = () => {
  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [selectedDepartment, setDepartment] = useState("");
  const [employeeGet, setEmployeeGet] = useState("null");
  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleSubCompany, setToggleSubCompany] = useState(
    sessionStorage.getItem("company_id"),
  );
  const [active, setActive] = useState("active");

  //! ******************************API start***************************//
  const getimprestname = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        // `${BASE_URL}/wfm/imprestbyaccount/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${toggleSubCompany}/`
        `${BASE_URL}/wfm/imprestbyaccount/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${toggleSubCompany}/${active}/`,
      );
      setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getimprestname();
  }, [fromdate, todate, selectedStatus, employeeGet, toggleSubCompany, active]);

  const [departmentLists, setDepartmentLists] = useState([]);
  const getDepartment = async () => {
    try {
      setBuffering1(true);
      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleSubCompany}/${active}/`,
      );
      setDepartmentLists(dep.data);
      // setFilteredData(dep.data);
    } catch (err) {
    } finally {
      setBuffering1(false);
    }
  };

  const getEmpcode = async () => {
    setBuffering2(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleSubCompany}/`,
        // `${BASE_URL}/wfm/ourcompanysRH/${sessionStorage.getItem("email")}/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setAllemployee(sortedList);
      // setAllemployee(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering2(false); // End Buffering
    }
  };

  useEffect(() => {
    getDepartment();
    getEmpcode();
  }, [toggleSubCompany, active]);
  //! *********** Employee Details Api End ***********

  const applyFilters = () => {
    let filteredData = outdutyname;

    if (selectedDepartment !== "") {
      filteredData = filteredData.filter(
        (employee) => employee.department === selectedDepartment,
      );
    }
    setFilteredData(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [outdutyname, selectedDepartment]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {/* {SUPER_ADMIN
              ? */}
            <div className="field-cont-div">
              <Office />
              <select
                onChange={(e) => setToggleSubCompany(e.target.value)}
                value={toggleSubCompany}
                className="attendance-input-field width-10vw  "
              >
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map((company) => (
                  <option value={company.id}>{company.title}</option>
                ))}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>
            {/* : null
            } */}

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ? <div className="spinner-vsmall"></div> : <Employee />}
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="null">Select Employee Code </option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer1 ? (
                <div className="spinner-vsmall"></div>
              ) : (
                <CircularGrid />
              )}
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDepartment}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="">All Department</option>
                {departmentLists
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>

                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new">
          {/* <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">Imprest </div>
          </div> */}
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-new">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Imprest Date</th>
                <th className="table-heading">Dates</th>
                <th className="table-heading ">Imprest Name</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Total Amount
                </th>
                <th className="table-heading">Days And Employee Count</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Person Name
                </th>
                <th className="table-heading">Remarks</th>
                <th className="table-heading">Status</th>
                <th
                  className="table-heading width-5vw"
                  style={{ textAlign: "center" }}
                >
                  Action
                </th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {filterData
                  .sort((a, b) => {
                    const dateA = a.admin_update_datetime
                      ? new Date(a.admin_update_datetime)
                      : null;
                    const dateB = b.admin_update_datetime
                      ? new Date(b.admin_update_datetime)
                      : null;
                    if (dateA && dateB) {
                      return dateB - dateA;
                    }
                    if (dateA) return -1;
                    if (dateB) return 1;
                    return 0;
                  })
                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr
                        className="custom-table-head-td"
                        title={`Accounts Status : ${i.account_leave_status}`}
                      >
                        <td className="table-body">{index + 1}</td>
                        {/* <td className="table-body">
                          {i.project_id ?
                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td className="table-body" >Project Code</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right word-wrap-20vw">
                                    {i.ref_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body text-left" >Project Name</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right word-wrap-20vw">
                                    {i.ref_project_name}
                                  </td>
                                </tr>

                              </tbody>
                            </table> :
                            <div className="align-center justify-center">
                              - No Project Referenced -
                            </div>
                          }
                        </td> */}
                        <td className="table-body">
                          {i?.mantra_project_details?.mantra_project_id ? (
                            // Priority 1: Mantra project exists
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right  word-wrap-10vw">
                                    {i?.mantra_project_details?.mantra_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right  word-wrap-15vw">
                                    {i?.mantra_project_details?.mantra_project_name}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : i?.project_id ? (
                            // Priority 2: Fallback to ref project
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right  word-wrap-10vw">
                                    {i?.ref_project_code}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                  <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right  word-wrap-15vw">
                                    {i?.ref_project_name}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            // Priority 3: No project at all
                            <div className="justify-center">
                              - No Project Referenced -
                            </div>
                          )}
                        </td>
                        <td
                          className="table-body"
                          style={{ textAlign: "center" }}
                        >
                          <CustomImageModal customStyle>
                            {i.profilepic ? (
                              <img
                                src={`${IMAGE_URL}${i.profilepic}`}
                                alt="profile"
                                className="profile-img"
                              />
                            ) : (
                              <UserDefaultLogo
                                user={{
                                  name: i.imprest_name,
                                  profilepic: i.profilepic,
                                }}
                                customStyleforParent={
                                  "reqOutDuty-default-logo-dashboard"
                                }
                                customStyleforChild={"small-profile"}
                              />
                            )}
                          </CustomImageModal>
                          <p>
                            {i.empcode} {i.imprest_name}
                          </p>
                        </td>

                        <td className="table-body">{formatDate(i.date)}</td>

                        <td
                          title="Approval Dates"
                          className="table-body width-10vw"
                        >
                          {i.rh_leave_status === "approved" ? (
                            <span
                              request-status={i.rh_leave_status}
                              className="request-status "
                            >
                              Rh ({i.rh_assigned}-{i.rh_assigned_name}) Approved
                              {i.rh_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {formatDateTime(i.rh_update_datetime).date}
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          {i.admin_leave_status === "approved" ? (
                            <span
                              request-status={i.admin_leave_status}
                              className="request-status "
                            >
                              Admin{" "}
                              {i.admin_update_by
                                ? `(${i.admin_update_by}-${i.admin_update_by_name})`
                                : ""}{" "}
                              Approved
                              {i.admin_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {formatDateTime(i.admin_update_datetime).date}
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          {i.account_leave_status === "approved" ? (
                            <span
                              request-status={i.account_leave_status}
                              className="request-status "
                            >
                              Accounts
                              {i.account_update_by
                                ? `(${i.account_update_by}-${i.account_update_by_name})`
                                : ""}{" "}
                              Approved
                              {i.account_update_datetime ? (
                                <>
                                  <br />
                                  At:{" "}
                                  {
                                    formatDateTime(i.account_update_datetime)
                                      .date
                                  }
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>

                        <td className="table-body word-wrap-20vw">
                          {/* {i.project_name} */}
                          {i?.mantra_project_details?.mantra_project_id
                            ? `${i?.mantra_project_details?.mantra_project_code}-${i?.mantra_project_details?.mantra_project_name}`
                            : `${i.project_name}`}
                        </td>

                        {i.rh_leave_status === "approved" ? (
                          <td
                            className="table-body"
                            title={`Reason For Change : \n${i.amount_change_reason}`}
                          >
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Transportation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_transportation || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Accommodation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_accomodation || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Approved Food
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(
                                      i.approved_fooding || 0,
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <b>
                                    <td
                                      className="table-body"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Approved Others
                                    </td>
                                  </b>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td
                                    className="align-right table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>
                                      {formatCurrencyIndian(
                                        i.other_details?.reduce(
                                          (sum, other) =>
                                            sum +
                                            (parseFloat(other.approved_other) ||
                                              0),
                                          0,
                                        ),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                                {i.other_details?.length > 0 ? (
                                  <>
                                    {i.other_details.map((other, index) => (
                                      <tr key={index}>
                                        <td
                                          className="table-body word-wrap-10vw"
                                          style={{
                                            paddingLeft: "5px",
                                            paddingBottom: "5px",
                                          }}
                                        >
                                          {other.other_name
                                            ? other.other_name
                                            : `Other-${index + 1}`}
                                        </td>
                                        <td style={{ padding: "0px 4px" }}>
                                          :
                                        </td>
                                        <td
                                          className="align-right"
                                          style={{ paddingBottom: "5px" }}
                                        >
                                          {formatCurrencyIndian(
                                            other.approved_other || 0,
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ) : (
                                  <tr>
                                    <td
                                      style={{
                                        paddingBottom: "5px",
                                        paddingLeft: "5px",
                                      }}
                                      colSpan={3}
                                    >
                                      No Other Amount
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <td>
                                    <b>Total</b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(i.approved_transportation) +
                                        Number(i.approved_accomodation) +
                                        Number(i.approved_fooding) +
                                        (i.other_details?.length > 0
                                          ? i.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(
                                                other.approved_other || 0,
                                              ),
                                            0,
                                          )
                                          : 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        ) : (
                          <td className="table-body">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Transportation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.transportation)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Accommodation
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.accomodation)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Food
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    {formatCurrencyIndian(i.fooding)}
                                  </td>
                                </tr>
                                <tr>
                                  <b>
                                    <td
                                      className="table-body"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Others
                                    </td>
                                  </b>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {i.other_details
                                        ?.reduce(
                                          (sum, other) =>
                                            sum +
                                            (parseFloat(other.amount) || 0),
                                          0,
                                        )
                                        .toLocaleString()}
                                    </b>
                                  </td>
                                </tr>
                                {i.other_details?.length > 0 ? (
                                  <>
                                    {i.other_details.map((other, index) => (
                                      <>
                                        <tr>
                                          <td
                                            style={{
                                              paddingLeft: "5px",
                                              paddingBottom: "5px",
                                            }}
                                            className="table-body word-wrap-10vw"
                                          >
                                            {other.other_name
                                              ? other.other_name
                                              : `Other-${index + 1}`}
                                          </td>
                                          <td style={{ padding: "0px 4px" }}>
                                            :
                                          </td>

                                          <td className="align-right">
                                            {formatCurrencyIndian(
                                              other.amount || 0,
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ))}
                                  </>
                                ) : (
                                  <td
                                    style={{
                                      paddingBottom: "5px",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    No Other Amount
                                  </td>
                                )}
                                <tr>
                                  <td
                                    className="table-body"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <b>Total </b>
                                  </td>
                                  <td style={{ padding: "0px 4px" }}>:</td>
                                  <td className="align-right">
                                    <b>
                                      {formatCurrencyIndian(
                                        Number(i.transportation) +
                                        Number(i.accomodation) +
                                        Number(i.fooding) +
                                        (i.other_details?.length > 0
                                          ? i.other_details.reduce(
                                            (total, other) =>
                                              total +
                                              Number(other.amount || 0),
                                            0,
                                          )
                                          : 0),
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        )}
                        <td className="table-body">
                          For <b>{i.no_of_days}</b> Days with <br />{" "}
                          <b>{i.person}</b>{" "}
                          {i.person > 1 ? "people." : "person."}
                        </td>
                        <td className="table-body">
                          <ul style={{ paddingLeft: "20px" }}>
                            {i.multiple_person_details?.map((items) => {
                              return (
                                <li>
                                  {items.emp_code} - {items.name}
                                  <br />
                                </li>
                              );
                            })}
                          </ul>
                        </td>
                        <td className="table-body">{i.remarks}</td>
                        <td className="table-body">
                          <span
                            request-status={i.rh_leave_status}
                            className="request-status"
                            title={`${i.rh_leave_status === "rejected" ? `TL Reason For Rejection : \n${i.rejection_reason}` : ""}`}
                          >
                            {i.rh_leave_status === "pending" ? (
                              "Pending For Rh Approval ⌛"
                            ) : i.rh_leave_status === "rejected" ? (
                              <>
                                Rh ✖,
                                <br />
                                Rh Reject Reason:
                                <br />"{i.rejection_reason}"
                              </>
                            ) : (
                              "Approved By Rh ✔,"
                            )}
                          </span>
                          <br />
                          <span
                            request-status={i.admin_leave_status}
                            className="request-status"
                            title={`${i.admin_leave_status === "rejected" ? `Admin Reason: ${i.admin_rejection_reason}` : ""}`}
                          >
                            {i.admin_leave_status === "rejected" ? (
                              <>
                                Admin ✖,
                                <br />
                                Admin Reject Reason: "{i.admin_rejection_reason}
                                "
                              </>
                            ) : i.admin_leave_status === "pending" ? (
                              "Pending For Admin Approval ⌛,"
                            ) : i.admin_leave_status === "approved" ? (
                              "Approved By Admin ✔,"
                            ) : (
                              "Admin Status: " + i.admin_leave_status
                            )}
                          </span>
                          <br />
                          <span
                            request-status={i.account_leave_status}
                            className="request-status"
                            title={`${i.account_leave_status === "rejected" ? `Account Reason: ${i.account_rejection_reason}` : ""}`}
                          >
                            {i.account_leave_status === "rejected" ? (
                              <>
                                Accounts ✖,
                                <br />
                                Accounts Reject Reason:
                                <br />"{i.account_rejection_reason}"
                              </>
                            ) : i.account_leave_status === "pending" ? (
                              "Pending For Account Approval ⌛"
                            ) : i.account_leave_status === "approved" ? (
                              "Approved By Accounts ✔,"
                            ) : (
                              "Accounts Status : " + i.account_leave_status
                            )}
                          </span>
                        </td>
                        <td className="table-body">
                          <div className="flex-row ">
                            <>
                              {i.account_leave_status === "approved" ? (
                                <></>
                              ) : (
                                <ImprestApprovedAccount
                                  i={i}
                                  getImprestname={getimprestname}
                                />
                              )}
                            </>
                            <>
                              {i.account_leave_status === "rejected" ? (
                                <></>
                              ) : (
                                // <ImprestDeleteAccount
                                //   i={i}
                                //   getImprestname={getimprestname}
                                // />
                                <></>
                              )}
                            </>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestExpensetableAccStage1 = () => {
  const location = useLocation();
  let filters_fromdate =
    location.state?.filter_fromdate !== null
      ? location.state?.filter_fromdate
      : "null";
  let filters_todate =
    location.state?.filter_todate !== null
      ? location.state?.filter_todate
      : "null";
  let filters_status =
    location.state?.filter_status !== null
      ? location.state?.filter_status
      : "pending";
  let filters_employee =
    location.state?.filter_employee !== null
      ? location.state?.filter_employee
      : "null";
  let filters_subcompany =
    location.state?.filter_subCompany !== null
      ? location.state?.filter_subCompany
      : "null";
  let filters_active =
    location.state?.filter_active !== null
      ? location.state?.filter_active
      : "null";

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [selectedStatus, setSelectedStatus] = useState(
    filters_status || "pending",
  );

  const [employeeGet, setEmployeeGet] = useState(filters_employee || "null");
  const [fromdate, setFromDate] = useState(filters_fromdate || "null");
  const [todate, setToDate] = useState(filters_todate || "null");
  const [toggleSubCompany, setToggleSubCompany] = useState(
    filters_subcompany || sessionStorage.getItem("company_id"),
  );
  const [active, setActive] = useState(filters_active || "active");

  //! ******************************API start***************************//
  const getexpansename = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
      const res = await axios.get(
        // `${BASE_URL}/wfm/expensebyaccount_a/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/${toggleSubCompany}/`
        `${BASE_URL}/wfm/expensebyaccount_a/${toggleSubCompany}/${active}/${employeeGet}/${selectedStatus}/${fromdate}/${todate}/`,
      );
      setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getexpansename();
  }, [fromdate, todate, selectedStatus, employeeGet, toggleSubCompany, active]);

  const getEmpcode = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleSubCompany}/`,
        // `${BASE_URL}/wfm/ourcompanysRH/${sessionStorage.getItem("email")}/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");

      setAllemployee(sortedList);
      // setAllemployee(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false); // End Buffering
    }
  };

  useEffect(() => {
    getEmpcode();
  }, [toggleSubCompany, active]);
  //! *********** Employee Details Api End ***********

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/requestExpenseSlip/`;
  const opener = "acc";
  let filter_fromdate = fromdate;
  let filter_todate = todate;
  let filter_status = selectedStatus;
  let filter_employee = employeeGet;
  let filter_subCompany = toggleSubCompany;
  let filter_active = active;

  // const openExenseSlip = (i) => {
  //   navigate(baseUrl + i.id + '/', { state: { i, opener } });
  // };

  const openExenseSlip = (i) => {
    navigate(baseUrl + i.id + "/", {
      state: {
        i,
        opener,
        filter_fromdate,
        filter_todate,
        filter_status,
        filter_employee,
        filter_subCompany,
        filter_active,
      },
    });
  };
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {/* {SUPER_ADMIN
              ? */}
            <div className="field-cont-div">
              <Office />
              <select
                onChange={(e) => setToggleSubCompany(e.target.value)}
                value={toggleSubCompany}
                className="attendance-input-field width-10vw  "
              >
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map((company) => (
                  <option value={company.id}>{company.title}</option>
                ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>
            {/* : null
            } */}

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer1 ? <div className="spinner-vsmall"></div> : <Employee />}
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="null">Select Employee Code </option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value || "null")}
                />
              </div>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="To Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value || "null")}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new">
          <div className="table-heading-flex">
            {/* <div className="repo-heading font-weight500 font-size-heading">Expense Requests</div> */}
            <div className="flex-row"></div>
          </div>
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-new">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Date</th>
                <th className="table-heading">
                  Expense <b>Against</b> Imprest
                </th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Imprest Amount
                </th>
                <th className="table-heading">Utilized Money</th>
                <th className="table-heading">Remaining Money</th>
                <th className="table-heading">Status</th>
                <th className="table-heading width-15vw">Remarks</th>
                <th className="table-heading">View/Action</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {outdutyname.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="9"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="table-body">{index + 1}</td>
                      {/* <td className="table-body">
                        {i.imprest_data?.project_id ?
                          <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <tbody>
                              <tr>
                                <td className="table-body" >Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" >Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_name}
                                </td>
                              </tr>

                            </tbody>
                          </table> :
                          <div className="align-center justify-center">
                            - No Project Referenced -
                          </div>
                        }
                      </td> */}
                      <td className="table-body">
                        {i?.imprest_data?.mantra_project_details
                          ?.mantra_project_id ? (
                          // Priority 1: Mantra project exists
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-10vw">
                                  {i?.imprest_data?.mantra_project_details?.mantra_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-15vw">
                                  {i?.imprest_data?.mantra_project_details?.mantra_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : i?.imprest_data?.project_id ? (
                          // Priority 2: Fallback to ref project
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-10vw">
                                  {i?.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-15vw">
                                  {i?.imprest_data?.ref_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : (
                          // Priority 3: No project at all
                          <div className="justify-center">
                            - No Project Referenced -
                          </div>
                        )}
                      </td>
                      <td
                        className="table-body"
                        style={{ textAlign: "center" }}
                      >
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{
                                name: i.emp_name,
                                profilepic: i.profilepic,
                              }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode} {i.emp_name}
                        </p>
                      </td>
                      <td className="table-body">{formatDate(i.date)}</td>
                      <td className="table-body word-wrap-20vw">
                        <span>{i.name}</span>
                        <br />
                        <b> Against </b>
                        <br />
                        <span className="word-wrap-10vw">
                          {i?.imprest_data?.mantra_project_details?.mantra_project_id
                            ? `${i?.imprest_data?.mantra_project_details?.mantra_project_code}-${i?.imprest_data?.mantra_project_details?.mantra_project_name}`
                            : `${i?.project_name}`}
                          {/* {i.project_name} */}
                        </span>
                      </td>
                      <td className="table-body">
                        <table
                          style={{ borderCollapse: "collapse", width: "100%" }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Transportation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_transportation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Accommodation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_accomodation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Food
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(i.approved_fooding || 0)}
                              </td>
                            </tr>
                            <tr>
                              <b>
                                <td
                                  className="table-body"
                                  style={{ paddingBottom: "5px" }}
                                >
                                  Others
                                </td>
                              </b>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    i.other_details?.reduce(
                                      (sum, other) =>
                                        sum + Number(other.approved_other || 0),
                                      0,
                                    ),
                                  )}
                                </b>
                              </td>
                            </tr>
                            {i.other_details?.length > 0 ? (
                              <>
                                {i.other_details.map((other, index) => (
                                  <tr key={index}>
                                    <td
                                      className="table-body word-wrap-10vw"
                                      style={{
                                        paddingLeft: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {other.other_name
                                        ? other.other_name
                                        : `Other-${index + 1}`}
                                    </td>
                                    <td style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right">
                                      {formatCurrencyIndian(
                                        other.approved_other || 0,
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  style={{
                                    padding: "0px 4px",
                                    paddingBottom: "5px",
                                  }}
                                  colSpan={3}
                                >
                                  No Other Expense
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                <b>Total</b>
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    Number(i.approved_transportation) +
                                    Number(i.approved_accomodation) +
                                    Number(i.approved_fooding) +
                                    (i.other_details?.length > 0
                                      ? i.other_details.reduce(
                                        (total, other) =>
                                          total +
                                          Number(other.approved_other || 0),
                                        0,
                                      )
                                      : 0),
                                  )}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      <td className="table-body align-center">
                        {i.utilized_amount
                          ? formatRoundoff2D(i.utilized_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body align-center">
                        {i.remaining_amount
                          ? formatRoundoff2D(i.remaining_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body">
                        <span
                          request-status={i.rh_status}
                          className="request-status"
                          title={
                            i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_status === "rejected"
                              ? "Rh ✖, "
                              : "Rh ✔, "}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status"
                          title={
                            i.account_status_a === "rejected"
                              ? `Account Reject Reason : ${i.account1_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_a === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_a === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_a === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_a === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 1: " + i.account_status_a}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status"
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected"
                            ? "Admin ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "pending"
                              ? "Pending For Admin Approval ⌛,"
                              : i.rh_status === "approved" &&
                                i.admin_status === "rejected"
                                ? "Admin ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved"
                                  ? "Admin ✔, "
                                  : "Admin Status: " + i.admin_status}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status "
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_b === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_b === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_b === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 2: " + i.account_status_b}
                        </span>
                      </td>
                      <td
                        title="Remarks and Approval Dates"
                        className="table-body"
                      >
                        <span
                          request-status={i.rh_status}
                          className="request-status "
                        >
                          {i.rh_status === "pending"
                            ? "-"
                            : i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : `Rh${i.rh_assigned ? `(${i.rh_assigned}-${i.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${i.rh_update_datetime ? `At: ${formatDateTime(i.rh_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status "
                        >
                          {i.account_status_a === "pending"
                            ? "-"
                            : i.account_status_a === "rejected"
                              ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                              : `Accounts${i.account_update_by ? `(${i.account_update_by}-${i.account_update_by_name}) ` : ""}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status "
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.admin_status === "pending"
                            ? "-"
                            : i.admin_status === "rejected"
                              ? `Admin Rejection Reason : ${i.admin_rejection_reason}`
                              : `Admin${i.admin_update_by ? `(${i.admin_update_by}-${i.admin_update_by_name}) ` : ""}: Approved After Final Verification  ${i.admin_update_datetime ? `At: ${formatDateTime(i.admin_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status "
                        >
                          {i.account_status_b === "pending"
                            ? "-"
                            : i.account_status_b === "rejected"
                              ? `Final Rejection Reason : ${i.account2_rejection_reason}`
                              : `Final${i.final_update_by ? `(${i.final_update_by}) ` : ""}: Approved And Settled ${i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date}` : ""}`}
                        </span>
                      </td>
                      <td className="table-body align-center">
                        <button
                          className="allproject-dashboard"
                          title="View using Navigate"
                          onClick={(e) => openExenseSlip(i)}
                        >
                          <Eye />
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestExpensetableAccStage2 = () => {
  const location = useLocation();
  let filters_fromdate =
    location.state?.filter_fromdate !== null
      ? location.state?.filter_fromdate
      : "null";
  let filters_todate =
    location.state?.filter_todate !== null
      ? location.state?.filter_todate
      : "null";
  let filters_status =
    location.state?.filter_status !== null
      ? location.state?.filter_status
      : "pending";
  let filters_employee =
    location.state?.filter_employee !== null
      ? location.state?.filter_employee
      : "null";
  let filters_subcompany =
    location.state?.filter_subCompany !== null
      ? location.state?.filter_subCompany
      : "null";
  let filters_active =
    location.state?.filter_active !== null
      ? location.state?.filter_active
      : "null";

  // *********** Employee Details Api Start ***********
  const [allemployee, setAllemployee] = useState([]);
  const [outdutyname, setOutdutyName] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [selectedStatus, setSelectedStatus] = useState(
    filters_status || "pending",
  );
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [employeeGet, setEmployeeGet] = useState(filters_employee || "null");
  const [fromdate, setFromDate] = useState(filters_fromdate || "null");
  const [todate, setToDate] = useState(filters_todate || "null");
  const [toggleSubCompany, setToggleSubCompany] = useState(
    filters_subcompany || sessionStorage.getItem("company_id"),
  );
  const [active, setActive] = useState(filters_active || "active");

  //! ******************************API start***************************//
  const getexpansename = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/expensebyaccount_b/${toggleSubCompany}/${active}/${employeeGet}/${selectedStatus}/${fromdate}/${todate}/`,
      );
      setOutdutyName(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getexpansename();
  }, [fromdate, todate, selectedStatus, employeeGet, toggleSubCompany, active]);

  const getEmpcode = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleSubCompany}/`,
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setAllemployee(sortedList);
      // setAllemployee(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getEmpcode();
  }, [toggleSubCompany, active]);
  //! *********** Employee Details Api End ***********

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/requestExpenseSlip/`;
  const opener = "accb";
  let filter_fromdate = fromdate;
  let filter_todate = todate;
  let filter_status = selectedStatus;
  let filter_employee = employeeGet;
  let filter_subCompany = toggleSubCompany;
  let filter_active = active;

  // const openExenseSlip = (i) => {
  //   navigate(baseUrl + i.id + '/', { state: { i, opener } });
  // };

  const openExenseSlip = (i) => {
    navigate(baseUrl + i.id + "/", {
      state: {
        i,
        opener,
        filter_fromdate,
        filter_todate,
        filter_status,
        filter_employee,
        filter_subCompany,
        filter_active,
      },
    });
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {/* {SUPER_ADMIN
              ? */}
            <div className="field-cont-div">
              <Office />
              <select
                onChange={(e) => setToggleSubCompany(e.target.value)}
                value={toggleSubCompany}
                className="attendance-input-field width-10vw  "
              >
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map((company) => (
                  <option value={company.id}>{company.title}</option>
                ))}
                ;
              </select>

              <hr className="field-cont-hr" />
            </div>
            {/* : null
            } */}

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => setActive(e.target.value)}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Employee />
              <select
                className="attendance-input-field width-15vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="null">Select Employee Code </option>
                {allemployee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value || "null")}
                />
              </div>

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <div className=" date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="To Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value || "null")}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background-new">
          <div className="table-heading-flex">
            {/* <div className="repo-heading font-weight500    font-size-heading">Expense Settlement</div> */}
            <div className="flex-row"></div>
          </div>
          <table className="">
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#fff",
                zIndex: "10",
              }}
            >
              <tr className="custom-table-head-tr-new">
                <th className="table-heading">S. No.</th>
                <th className="table-heading">Project Reference</th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Employee
                </th>
                <th className="table-heading">Date</th>
                <th className="table-heading">
                  Expense <b>Against</b> Imprest
                </th>
                <th className="table-heading" style={{ textAlign: "center" }}>
                  Imprest Amount
                </th>
                <th className="table-heading">Utilized Money</th>
                <th className="table-heading">Remaining Money</th>
                <th className="table-heading">View</th>
                <th className="table-heading">Status</th>
                <th className="table-heading width-15vw">Remarks</th>
                <th className="table-heading">View/Action</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {outdutyname.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="8"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="table-body">{index + 1}</td>
                      {/* <td className="table-body">
                        {i.imprest_data?.project_id ?
                          <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <tbody>
                              <tr>
                                <td className="table-body" >Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" >Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-20vw">
                                  {i.imprest_data?.ref_project_name}
                                </td>
                              </tr>

                            </tbody>
                          </table> :
                          <div className="align-center justify-center">
                            - No Project Referenced -
                          </div>
                        }
                      </td> */}

                      <td className="table-body">
                        {i?.imprest_data?.mantra_project_details
                          ?.mantra_project_id ? (
                          // Priority 1: Mantra project exists
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-10vw">
                                  {i?.imprest_data?.mantra_project_details?.mantra_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-15vw">
                                  {i?.imprest_data?.mantra_project_details?.mantra_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : i?.imprest_data?.project_id ? (
                          // Priority 2: Fallback to ref project
                          <table
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-10vw">
                                  {i?.imprest_data?.ref_project_code}
                                </td>
                              </tr>
                              <tr>
                                <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                <td className="align-right word-wrap-15vw">
                                  {i?.imprest_data?.ref_project_name}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : (
                          // Priority 3: No project at all
                          <div className="justify-center">
                            - No Project Referenced -
                          </div>
                        )}
                      </td>
                      <td
                        className="table-body"
                        style={{ textAlign: "center" }}
                      >
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{
                                name: i.emp_name,
                                profilepic: i.profilepic,
                              }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode} {i.emp_name}
                        </p>
                      </td>
                      <td className="table-body">{formatDate(i.date)}</td>
                      <td className="table-body word-wrap-20vw">
                        <span>{i.name}</span>
                        <br />
                        <b> Against </b>
                        <br />
                        <span className="word-wrap-10vw">
                          {i?.imprest_data?.mantra_project_details?.mantra_project_id
                            ? `${i?.imprest_data?.mantra_project_details?.mantra_project_code}-${i?.imprest_data?.mantra_project_details?.mantra_project_name}`
                            : `${i?.project_name}`}
                          {/* {i.project_name} */}
                        </span>
                      </td>
                      <td className="table-body">
                        <table
                          style={{ borderCollapse: "collapse", width: "100%" }}
                        >
                          <tbody>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Transportation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_transportation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Accommodation
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(
                                  i.approved_accomodation || 0,
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                Food
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                {formatCurrencyIndian(i.approved_fooding || 0)}
                              </td>
                            </tr>
                            <tr>
                              <b>
                                <td
                                  className="table-body "
                                  style={{ paddingBottom: "5px" }}
                                >
                                  Others
                                </td>
                              </b>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right ">
                                <b>
                                  {formatCurrencyIndian(
                                    i.other_details?.reduce(
                                      (sum, other) =>
                                        sum + Number(other.approved_other || 0),
                                      0,
                                    ),
                                  )}
                                </b>
                              </td>
                            </tr>
                            {i.other_details?.length > 0 ? (
                              <>
                                {i.other_details.map((other, index) => (
                                  <tr key={index}>
                                    <td
                                      className="table-body word-wrap-10vw"
                                      style={{
                                        paddingLeft: "5px",
                                        paddingBottom: "5px",
                                      }}
                                    >
                                      {other.other_name
                                        ? other.other_name
                                        : `Other-${index + 1}`}
                                    </td>
                                    <td style={{ padding: "0px 4px" }}>:</td>
                                    <td className="align-right">
                                      {formatCurrencyIndian(
                                        other.approved_other || 0,
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  style={{
                                    padding: "0px 4px",
                                    paddingBottom: "5px",
                                  }}
                                  colSpan={3}
                                >
                                  No Other Expense
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td
                                className="table-body"
                                style={{ paddingBottom: "5px" }}
                              >
                                <b>Total</b>
                              </td>
                              <td style={{ padding: "0px 4px" }}>:</td>
                              <td className="align-right">
                                <b>
                                  {formatCurrencyIndian(
                                    Number(i.approved_transportation) +
                                    Number(i.approved_accomodation) +
                                    Number(i.approved_fooding) +
                                    (i.other_details?.length > 0
                                      ? i.other_details.reduce(
                                        (total, other) =>
                                          total +
                                          Number(other.approved_other || 0),
                                        0,
                                      )
                                      : 0),
                                  )}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="table-body align-center">
                        {i.utilized_amount
                          ? formatRoundoff2D(i.utilized_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body align-center">
                        {i.remaining_amount
                          ? formatRoundoff2D(i.remaining_amount)
                          : "-"}{" "}
                        Rs
                      </td>
                      <td className="table-body">
                        <button
                          className="allproject-dashboard"
                          title="View using Navigate"
                          onClick={(e) => openExenseSlip(i)}
                        >
                          <Eye />
                        </button>
                      </td>
                      <td className="table-body">
                        <span
                          request-status={i.rh_status}
                          className="request-status "
                          title={
                            i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_status === "rejected"
                              ? "Rh ✖, "
                              : "Rh ✔, "}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status "
                          title={
                            i.account_status_a === "rejected"
                              ? `Account Reject Reason : ${i.account1_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_a === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_a === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_a === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_a === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 1: " + i.account_status_a}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status "
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected"
                            ? "Admin ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "pending"
                              ? "Pending For Admin Approval ⌛,"
                              : i.rh_status === "approved" &&
                                i.admin_status === "rejected"
                                ? "Admin ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved"
                                  ? "Admin ✔, "
                                  : "Admin Status: " + i.admin_status}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status "
                        >
                          {i.rh_status === "rejected" &&
                            i.admin_status === "rejected" &&
                            i.account_status_b === "rejected"
                            ? "Account ✖, "
                            : i.rh_status === "approved" &&
                              i.admin_status === "approved" &&
                              i.account_status_b === "pending"
                              ? "Pending For Account Approval ⌛"
                              : i.rh_status === "approved" &&
                                i.admin_status === "approved" &&
                                i.account_status_b === "rejected"
                                ? "Accounts ✖, "
                                : i.rh_status === "approved" &&
                                  i.admin_status === "approved" &&
                                  i.account_status_b === "approved"
                                  ? "Accounts ✔, "
                                  : "Accounts Stage 2: " + i.account_status_b}
                        </span>
                      </td>
                      <td
                        title="Remarks and Approval Dates"
                        className="table-body"
                      >
                        <span
                          request-status={i.rh_status}
                          className="request-status "
                        >
                          {i.rh_status === "pending"
                            ? "-"
                            : i.rh_status === "rejected"
                              ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                              : `Rh${i.rh_assigned ? `(${i.rh_assigned}-${i.rh_assigned_name}) ` : ""}: Verified Amounts for Bills ${i.rh_update_datetime ? `At: ${formatDateTime(i.rh_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_a}
                          className="request-status "
                        >
                          {i.account_status_a === "pending"
                            ? "-"
                            : i.account_status_a === "rejected"
                              ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                              : `Accounts${i.account_update_by ? `(${i.account_update_by}-${i.account_update_by_name})) ` : ""}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.admin_status}
                          className="request-status "
                          title={
                            i.admin_status === "rejected"
                              ? `Admin Reject Reason : ${i.admin_rejection_reason}`
                              : ""
                          }
                        >
                          {i.admin_status === "pending"
                            ? "-"
                            : i.admin_status === "rejected"
                              ? `Admin Rejection Reason : ${i.admin_rejection_reason}`
                              : `Admin${i.admin_update_by ? `(${i.admin_update_by}-${i.admin_update_by_name}) ` : ""}: Approved After Final Verification  ${i.admin_update_datetime ? `At: ${formatDateTime(i.admin_update_datetime).date}` : ""}`}
                        </span>
                        <br />
                        <span
                          request-status={i.account_status_b}
                          className="request-status "
                        >
                          {i.account_status_b === "pending"
                            ? "-"
                            : i.account_status_b === "rejected"
                              ? `Final Rejection Reason : ${i.account2_rejection_reason}`
                              : `Final${i.final_update_by ? `(${i.final_update_by}) ` : ""}: Approved And Settled ${i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date}` : ""}`}
                        </span>
                      </td>
                      <td className="table-body align-center">
                        <AccountBExpenseFinalize
                          i={i}
                          getExpanseData={getexpansename}
                        />
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const RequestClockInTableHR = () => {
  // const [checkedItems, setCheckedItems] = useState([]);
  const [employeeGet, setEmployeeGet] = useState("null");
  const [fromdate, setFromDate] = useState("null");
  const [todate, setToDate] = useState("null");
  const [selectedStatus, setSelectedStatus] = useState("null");
  const [buffer, setBuffering] = useState(true); //buffering logic

  // *********** Employee Details Api Start ***********
  const [clockInList, setClockInList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const getEmpList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanysRH/${sessionStorage.getItem("email")}/`,
      );
      const sortedData = customSortByKey(res.data, "emp_code");
      setEmployeeList(sortedData);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const getClockInList = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/clockinrequest/${fromdate}/${todate}/null/${selectedStatus}/${employeeGet}/`,
      );
      setClockInList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };
  useEffect(() => {
    getEmpList();
    getClockInList();
  }, [selectedStatus, employeeGet, fromdate, todate]);

  // *********** Employee Details Api End ***********

  // const handleCheckboxChange = (id) => {
  //   const currentIndex = checkedItems.indexOf(id);
  //   const newCheckedItems = [...checkedItems];

  //   if (currentIndex === -1) {
  //     newCheckedItems.push(id);
  //   } else {
  //     newCheckedItems.splice(currentIndex, 1);
  //   }

  //   setCheckedItems(newCheckedItems);
  // };

  const calculateTimeDifference = (inTime, outTime) => {
    const parseTime = (time) => {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return new Date(0, 0, 0, hours, minutes, seconds);
    };

    const inTimeDate = parseTime(inTime);
    const outTimeDate = parseTime(outTime);

    const differenceInMilliseconds = outTimeDate - inTimeDate;
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

    return differenceInHours.toFixed(2) + " hrs";
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="attendance-heading  font-weight500    font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw   date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <hr />
            </div>
            <div className="field-cont-div">
              <div className="date-uppercase ">
                <input
                  className="attendance-input-field width-10vw date-field date-field-filter"
                  placeholder="From Date"
                  type="date"
                  value={todate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <Filter />
              <select
                title="Request Status"
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="null">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Employee />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={employeeGet}
                onChange={(e) => setEmployeeGet(e.target.value)}
              >
                <option value="null">Select Employee Code</option>
                {employeeList
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i, index) => (
                    <option value={i.emp_code}>
                      {i.emp_code} - {i.name}
                    </option>
                  ))}
                ;
              </select>
            </div>
          </div>

          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">
              Clock In Requests
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                {/* <th className="align-left">
                  <input type="checkbox" onChange={(e) => {
                    if (e.target.checked) {
                      const ids = clockInList.map((data) => data.id);
                      setCheckedItems(ids);
                    } else {
                      setCheckedItems([]);
                    }
                  }} />
                </th> */}

                {/* <th className="align-center">Date</th> */}
                <th className="align-center">Empolyee Name</th>
                <th className="align-center">Date</th>
                <th className="align-center">Clock In</th>
                <th className="align-center">Clock Out</th>
                <th className="align-center">Working Hours</th>
                <th className="align-center">Log</th>
                {/* <th className="align-center">Location</th> */}
                <th className="align-right ">Status</th>
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner"></div> //buffering logic
            ) : (
              <tbody>
                {clockInList.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>

                      {/* <td className="align-center">{i.date}</td> */}
                      <td className="align-center">
                        <CustomImageModal customStyle>
                          {i.profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.profilepic}`}
                              alt="profile"
                              className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.name, profilepic: i.profilepic }}
                              customStyleforParent={
                                "reqOutDuty-default-logo-dashboard"
                              }
                              customStyleforChild={"small-profile"}
                            />
                          )}
                        </CustomImageModal>
                        <p>
                          {i.empcode}-{i.name}
                        </p>
                      </td>
                      {/* <td className="align-center">{i.empcode}-{i.name}</td> */}
                      <td className="align-center">
                        {formattedDateLong(i.date)}
                      </td>
                      <td className="align-center">
                        <p>{i.in_time}</p>
                        <p>{i.in_time_location}</p>
                      </td>
                      {/* <td className="align-center">{i.out_time}</td> */}
                      {/* <td className="align-center">{i.work_duration}</td> */}
                      <td className="align-center text-capitalize">
                        <p>{i.out_time}</p>
                        <p>{i.out_time_location}</p>
                      </td>
                      <td className="align-center">
                        {calculateTimeDifference(i.in_time, i.out_time)}
                      </td>
                      <td className="align-center text-capitalize">
                        <ClockInLogTable log={i.logs} />
                      </td>
                      <td className="align-right ">
                        <span
                          request-status={i.rh_leave_status}
                          className="request-status align-center"
                        >
                          {i.rh_leave_status === "pending"
                            ? "Pending For Rh Approval ⌛"
                            : i.rh_leave_status === "rejected"
                              ? "Rh Rejected ✖, "
                              : "Rh Approved ✔, "}
                        </span>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const ClockInLogTable = ({ log }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    // getDesignationEmployees(designation.id);
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // useEffect(() => {
  //   getDesignationEmployees();
  // }, []);

  // const navigate = useNavigate();
  // const Viewdetails = (emp_code, user_detail) => {
  //   navigate(`/hr/userdetailscrud/${emp_code}/${user_detail}/`);
  // };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View logs
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Body>
          <>
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Clock In Log
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <SearchBig />
                    </div>
                    <div>
                      <input
                        placeholder="Search Place"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">Sr. No.</th>
                    <th className="align-left">Picture</th>

                    <th className="align-center">Punch Time</th>
                    <th className="align-center">Punch Location</th>
                    {/* <th className="align-center">Employee View</th> */}
                  </tr>
                </thead>
                <tbody>
                  {log
                    .filter((e) =>
                      e.placename
                        .toString()
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()),
                    )
                    ?.sort((a, b) => a.punch_time - b.punch_time)
                    .map((i, index) => (
                      <React.Fragment key={index}>
                        {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">
                            <CustomImageModal customStyle>
                              {i.image ? (
                                <img
                                  src={`${i.image}`}
                                  alt="profile"
                                  className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{ name: i.name, profilepic: i.image }}
                                  customStyleforParent={
                                    "reqOutDuty-default-logo-dashboard"
                                  }
                                  customStyleforChild={"small-profile"}
                                />
                              )}
                            </CustomImageModal>
                          </td>
                          <td className="align-center">{i.punch_time}</td>
                          <td className="align-center">{i.placename}</td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AttendancePolicyLogTable = () => {
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [buffer, setBuffering] = useState(true);
  const [logList, setLogList] = useState([]); // Master list of all logs

  const [selectedDivision, setDivision] = useState(
    sessionStorage.getItem("company_id") || "null"
  );

  const today = new Date();
  const currentMonth = (today.getMonth() + 1).toString();
  const currentYear = today.getFullYear().toString();

  const [startMonth, setStartMonth] = useState(currentMonth);
  const [startYear, setStartYear] = useState(currentYear);
  // (You might not need endMonth/endYear if you are strictly filtering by a single month)
  const [endMonth, setEndMonth] = useState(currentMonth);
  const [endYear, setEndYear] = useState(currentYear);

  const startDateValue = `${startYear}-${startMonth.padStart(2, "0")}`;
  const endDateValue = `${endYear}-${endMonth.padStart(2, "0")}`;

  // *********** Api Call Start ***********
  const getPolicyLogs = async () => {
    setBuffering(true);
    try {
      // Fetch all logs once for frontend filtering
      const res = await axios.get(`${BASE_URL}/wfm/attendance-policy-logs/`);
      setLogList(res.data);
    } catch (err) {
      console.error(err);
      // handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };
  // *********** Api Call End ***********

  // Fetch only on component mount since we are doing frontend filtering
  useEffect(() => {
    getPolicyLogs();
  }, []);

  // ==========================================
  // FRONTEND FILTERING LOGIC
  // ==========================================
  const filteredLogs = useMemo(() => {
    return logList.filter((log) => {
      // 1. Division Filter
      // If "null" or empty string, show all. Otherwise, match the sub_company ID.
      const matchDivision =
        selectedDivision === "null" ||
        selectedDivision === "" ||
        log.sub_company === selectedDivision;

      // 2. Month & Year Filter
      // Extract month and year from the log's created_at date
      const logDate = new Date(log.created_at);
      const logMonth = (logDate.getMonth() + 1).toString();
      const logYear = logDate.getFullYear().toString();

      const matchDate =
        logMonth === startMonth.toString() &&
        logYear === startYear.toString();

      // Log must pass both filters
      return matchDivision && matchDate;
    });
  }, [logList, selectedDivision, startMonth, startYear]);
  // ==========================================


  // Utility to determine the user who performed the action
  const renderActionUser = (log) => {
    const user = log.created_by || log.updated_by;
    if (user) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <span style={{ fontWeight: "500" }}>{user.name}</span>
          <span style={{ fontSize: "12px", color: "#666" }}>({user.emp_code})</span>
        </div>
      );
    }
    return <span style={{ color: "#999" }}>System / Unknown</span>;
  };

  // Utility to extract Policy Name
  const getPolicyName = (log) => {
    if (log.new_data?.name) return log.new_data.name;
    if (log.previous_data?.name) return log.previous_data.name;
    return <span style={{ color: "#999", fontStyle: "italic" }}>N/A</span>;
  };

  const renderChanges = (log) => {
    if (log.action === "created") {
      return (
        <span style={{ color: "green", fontWeight: "500" }}>
          Policy Initialized
        </span>
      );
    }

    if (log.action === "deleted") {
      return (
        <span style={{ color: "red", fontWeight: "500" }}>
          Policy Removed
        </span>
      );
    }

    if (log.action === "updated") {
      const changedKeys = Object.keys(log.new_data || {});
      return changedKeys.map((key) => (
        <div
          key={key}
          style={{
            fontSize: "13px",
            marginBottom: "4px",
            padding: "4px",
            backgroundColor: "#f9f9f9",
            borderRadius: "4px",
            borderLeft: "3px solid #ff9800",
          }}
        >
          <strong className="text-capitalize">
            {key.replace(/_/g, " ")}:
          </strong>{" "}
          <span style={{ textDecoration: "line-through", color: "#888", marginRight: "4px" }}>
            {String(log.previous_data?.[key] ?? "null")}
          </span>{" "}
          ➔{" "}
          <span style={{ color: "#000", fontWeight: "500" }}>
            {String(log.new_data?.[key] ?? "null")}
          </span>
        </div>
      ));
    }
    return "-";
  };

  return (
    <>
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500 font-size-heading">
          {" "}
        </div>
        <div className="attendance-subcont">
          <div className="field-cont">
            {SUPER_ADMIN ? (
              <div className="field-cont-div">
                <select
                  className="attendance-input-field width-10vw date-field"
                  type="text"
                  value={selectedDivision}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  <option value="null">All Companies</option>
                  {SUB_COMPANIES.sort((a, b) => a.title.localeCompare(b.title)).map(
                    (i) => (
                      <option key={i.id} value={i.id}>
                        {i.title}
                      </option>
                    )
                  )}
                </select>
                <hr className="field-cont-hr" />
              </div>
            ) : null}

            <div className="field-cont-div">
              <input
                type="month"
                className="attendance-input-field calender-input width-10vw"
                value={startDateValue}
                max={endDateValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    const [year, month] = value.split("-");
                    setStartYear(year);
                    setStartMonth(month.replace(/^0+/, ""));
                  }
                }}
              />
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont"></div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Attendance Policy Activity Logs
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left width-5vw">Sr.no</th>
                <th className="width-10vw">Policy Name</th>
                <th className="width-15vw">Changes Made</th>
                <th className="align-center width-10vw">Action</th>
                <th className="align-center width-15vw">Updated By</th>
                <th className="align-center width-15vw">Updated At</th>
              </tr>
            </thead>
            {buffer ? (
              <tbody>
                <tr>
                  <td colSpan="6">
                    <div className="spinner"></div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {/* USE FILTERED LOGS HERE INSTEAD OF logList */}
                {filteredLogs
                  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                  .map((log, index) => (
                    <React.Fragment key={log.id}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>

                        <td className="align-left font-weight500">
                          {getPolicyName(log)}
                        </td>

                        <td className="align-left">
                          {renderChanges(log)}
                        </td>

                        <td className="align-center text-capitalize font-weight500">
                          {log.action}
                        </td>
                        
                        <td className="align-center">
                          {renderActionUser(log)}
                        </td>

                        <td className="align-center">
                          {formatDateTime(log.created_at).longdatetime}
                        </td>
                        
                      </tr>
                    </React.Fragment>
                  ))}
                {/* USE FILTERED LOGS LENGTH HERE */}
                {filteredLogs.length === 0 && (
                  <tr>
                    <td colSpan="6" className="align-center" style={{ padding: "20px" }}>
                      No policy change logs found for the selected criteria.
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export {
  Requestoutdutytable,
  RequestLeavetable,
  LogCompensatorytable,
  HODCompensatoryLogTable,
  LeavesChangeLogTable,
  HODLeavesLogTable,
  RHLeaveApprovalDelayLogTable,
  RHOutDutyApprovalDelayLogTable,
  HRNotificationLogTable,
  HODNotificationLogTable,
  RequestImpresttableHOD,
  RequestExpensetableHOD,
  RequestImpresttableAdmin,
  RequestExpensetableAdmin,
  RequestImpresttableAcc,
  RequestExpensetableAccStage1,
  RequestExpensetableAccStage2,
  RequestClockInTableHR,
  ClockInLogTable,
  AttendancePolicyLogTable
};
